// AUTO-GENERATED — vendored snapshot of the Google Fonts library (IMM-391.2.1).
// Source: https://fonts.google.com/metadata/fonts (familyMetadataList).
// Regenerate periodically (parent Resolved Decision 3); do not hand-edit entries.
// Each entry is a family name plus the weight keys the family ships (e.g. "400",
// "700", "400i" for italics). Lint/format-ignored as generated data.

export type GoogleFontFamily = {
  readonly family: string;
  readonly weights: readonly string[];
};

export const GOOGLE_FONTS: readonly GoogleFontFamily[] = [
  { family: "ABeeZee", weights: ["400", "400i"] },
  { family: "Abel", weights: ["400"] },
  { family: "Abhaya Libre", weights: ["400", "500", "600", "700", "800"] },
  { family: "Aboreto", weights: ["400"] },
  { family: "Abril Fatface", weights: ["400"] },
  { family: "Abyssinica SIL", weights: ["400"] },
  { family: "Aclonica", weights: ["400"] },
  { family: "Acme", weights: ["400"] },
  { family: "Actor", weights: ["400"] },
  { family: "Adamina", weights: ["400"] },
  { family: "ADLaM Display", weights: ["400"] },
  { family: "Advent Pro", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900", "100i", "200i", "300i", "400i", "500i", "600i", "700i", "800i", "900i"] },
  { family: "Afacad", weights: ["400", "500", "600", "700", "400i", "500i", "600i", "700i"] },
  { family: "Afacad Flux", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900", "1000"] },
  { family: "Agbalumo", weights: ["400"] },
  { family: "Agdasima", weights: ["400", "700"] },
  { family: "Agu Display", weights: ["400"] },
  { family: "Aguafina Script", weights: ["400"] },
  { family: "Akatab", weights: ["400", "500", "600", "700", "800", "900"] },
  { family: "Akaya Kanadaka", weights: ["400"] },
  { family: "Akaya Telivigala", weights: ["400"] },
  { family: "Akronim", weights: ["400"] },
  { family: "Akshar", weights: ["300", "400", "500", "600", "700"] },
  { family: "Akt", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Aladin", weights: ["400"] },
  { family: "Alan Sans", weights: ["300", "400", "500", "600", "700", "800", "900"] },
  { family: "Alata", weights: ["400"] },
  { family: "Alatsi", weights: ["400"] },
  { family: "Albert Sans", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900", "100i", "200i", "300i", "400i", "500i", "600i", "700i", "800i", "900i"] },
  { family: "Aldrich", weights: ["400"] },
  { family: "Alef", weights: ["400", "700"] },
  { family: "Alegreya", weights: ["400", "500", "600", "700", "800", "900", "400i", "500i", "600i", "700i", "800i", "900i"] },
  { family: "Alegreya Sans", weights: ["100", "300", "400", "500", "700", "800", "900", "100i", "300i", "400i", "500i", "700i", "800i", "900i"] },
  { family: "Alegreya Sans SC", weights: ["100", "300", "400", "500", "700", "800", "900", "100i", "300i", "400i", "500i", "700i", "800i", "900i"] },
  { family: "Alegreya SC", weights: ["400", "500", "700", "800", "900", "400i", "500i", "700i", "800i", "900i"] },
  { family: "Aleo", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900", "100i", "200i", "300i", "400i", "500i", "600i", "700i", "800i", "900i"] },
  { family: "Alex Brush", weights: ["400"] },
  { family: "Alexandria", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Alfa Slab One", weights: ["400"] },
  { family: "Alice", weights: ["400"] },
  { family: "Alien Block", weights: ["400"] },
  { family: "Alike", weights: ["400"] },
  { family: "Alike Angular", weights: ["400"] },
  { family: "Alkalami", weights: ["400"] },
  { family: "Alkatra", weights: ["400", "500", "600", "700"] },
  { family: "Allan", weights: ["400", "700"] },
  { family: "Allerta", weights: ["400"] },
  { family: "Allerta Stencil", weights: ["400"] },
  { family: "Allison", weights: ["400"] },
  { family: "Allkin", weights: ["400"] },
  { family: "Allura", weights: ["400"] },
  { family: "Almarai", weights: ["300", "400", "700", "800"] },
  { family: "Almendra", weights: ["400", "700", "400i", "700i"] },
  { family: "Almendra Display", weights: ["400"] },
  { family: "Almendra SC", weights: ["400"] },
  { family: "Alumni Sans", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900", "100i", "200i", "300i", "400i", "500i", "600i", "700i", "800i", "900i"] },
  { family: "Alumni Sans Collegiate One", weights: ["400", "400i"] },
  { family: "Alumni Sans Inline One", weights: ["400", "400i"] },
  { family: "Alumni Sans Pinstripe", weights: ["400", "400i"] },
  { family: "Alumni Sans SC", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900", "100i", "200i", "300i", "400i", "500i", "600i", "700i", "800i", "900i"] },
  { family: "Alyamama", weights: ["300", "400", "500", "600", "700", "800", "900"] },
  { family: "Amarante", weights: ["400"] },
  { family: "Amaranth", weights: ["400", "700", "400i", "700i"] },
  { family: "Amarna", weights: ["100", "200", "300", "400", "500", "600", "700", "100i", "200i", "300i", "400i", "500i", "600i", "700i"] },
  { family: "Amatic SC", weights: ["400", "700"] },
  { family: "Amethysta", weights: ["400"] },
  { family: "Amiko", weights: ["400", "600", "700"] },
  { family: "Amiri", weights: ["400", "700", "400i", "700i"] },
  { family: "Amiri Quran", weights: ["400"] },
  { family: "Amita", weights: ["400", "700"] },
  { family: "Anaheim", weights: ["400", "500", "600", "700", "800"] },
  { family: "Ancizar Sans", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900", "1000", "1000i", "100i", "200i", "300i", "400i", "500i", "600i", "700i", "800i", "900i"] },
  { family: "Ancizar Serif", weights: ["300", "400", "500", "600", "700", "800", "900", "300i", "400i", "500i", "600i", "700i", "800i", "900i"] },
  { family: "Andada Pro", weights: ["400", "500", "600", "700", "800", "400i", "500i", "600i", "700i", "800i"] },
  { family: "Andika", weights: ["400", "700", "400i", "700i"] },
  { family: "Anek Bangla", weights: ["100", "200", "300", "400", "500", "600", "700", "800"] },
  { family: "Anek Devanagari", weights: ["100", "200", "300", "400", "500", "600", "700", "800"] },
  { family: "Anek Gujarati", weights: ["100", "200", "300", "400", "500", "600", "700", "800"] },
  { family: "Anek Gurmukhi", weights: ["100", "200", "300", "400", "500", "600", "700", "800"] },
  { family: "Anek Kannada", weights: ["100", "200", "300", "400", "500", "600", "700", "800"] },
  { family: "Anek Latin", weights: ["100", "200", "300", "400", "500", "600", "700", "800"] },
  { family: "Anek Malayalam", weights: ["100", "200", "300", "400", "500", "600", "700", "800"] },
  { family: "Anek Odia", weights: ["100", "200", "300", "400", "500", "600", "700", "800"] },
  { family: "Anek Tamil", weights: ["100", "200", "300", "400", "500", "600", "700", "800"] },
  { family: "Anek Telugu", weights: ["100", "200", "300", "400", "500", "600", "700", "800"] },
  { family: "Angkor", weights: ["400"] },
  { family: "Annapurna SIL", weights: ["400", "700"] },
  { family: "Annie Use Your Telescope", weights: ["400"] },
  { family: "Anonymous Pro", weights: ["400", "700", "400i", "700i"] },
  { family: "Anta", weights: ["400"] },
  { family: "Antic", weights: ["400"] },
  { family: "Antic Didone", weights: ["400"] },
  { family: "Antic Slab", weights: ["400"] },
  { family: "Anton", weights: ["400"] },
  { family: "Anton SC", weights: ["400"] },
  { family: "Antonio", weights: ["100", "200", "300", "400", "500", "600", "700"] },
  { family: "Anuphan", weights: ["100", "200", "300", "400", "500", "600", "700"] },
  { family: "Anybody", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900", "100i", "200i", "300i", "400i", "500i", "600i", "700i", "800i", "900i"] },
  { family: "Aoboshi One", weights: ["400"] },
  { family: "AR One Sans", weights: ["400", "500", "600", "700"] },
  { family: "Arapey", weights: ["400", "400i"] },
  { family: "Arbutus", weights: ["400"] },
  { family: "Arbutus Slab", weights: ["400"] },
  { family: "Architects Daughter", weights: ["400"] },
  { family: "Archivo", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900", "100i", "200i", "300i", "400i", "500i", "600i", "700i", "800i", "900i"] },
  { family: "Archivo Black", weights: ["400"] },
  { family: "Archivo Narrow", weights: ["400", "500", "600", "700", "400i", "500i", "600i", "700i"] },
  { family: "Are You Serious", weights: ["400"] },
  { family: "Aref Ruqaa", weights: ["400", "700"] },
  { family: "Aref Ruqaa Ink", weights: ["400", "700"] },
  { family: "Arima", weights: ["100", "200", "300", "400", "500", "600", "700"] },
  { family: "Arimo", weights: ["400", "500", "600", "700", "400i", "500i", "600i", "700i"] },
  { family: "Arizonia", weights: ["400"] },
  { family: "Armata", weights: ["400"] },
  { family: "Arsenal", weights: ["400", "700", "400i", "700i"] },
  { family: "Arsenal SC", weights: ["400", "700", "400i", "700i"] },
  { family: "Artifika", weights: ["400"] },
  { family: "Arvo", weights: ["400", "700", "400i", "700i"] },
  { family: "Arya", weights: ["400", "700"] },
  { family: "Asap", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900", "100i", "200i", "300i", "400i", "500i", "600i", "700i", "800i", "900i"] },
  { family: "Asap Condensed", weights: ["200", "300", "400", "500", "600", "700", "800", "900", "200i", "300i", "400i", "500i", "600i", "700i", "800i", "900i"] },
  { family: "Asar", weights: ["400"] },
  { family: "Asimovian", weights: ["400"] },
  { family: "Asset", weights: ["400"] },
  { family: "Assistant", weights: ["200", "300", "400", "500", "600", "700", "800"] },
  { family: "Asta Sans", weights: ["300", "400", "500", "600", "700", "800"] },
  { family: "Astloch", weights: ["400", "700"] },
  { family: "Asul", weights: ["400", "700"] },
  { family: "Athiti", weights: ["200", "300", "400", "500", "600", "700"] },
  { family: "Atkinson Hyperlegible", weights: ["400", "700", "400i", "700i"] },
  { family: "Atkinson Hyperlegible Mono", weights: ["200", "300", "400", "500", "600", "700", "800", "200i", "300i", "400i", "500i", "600i", "700i", "800i"] },
  { family: "Atkinson Hyperlegible Next", weights: ["200", "300", "400", "500", "600", "700", "800", "200i", "300i", "400i", "500i", "600i", "700i", "800i"] },
  { family: "Atma", weights: ["300", "400", "500", "600", "700"] },
  { family: "Atomic Age", weights: ["400"] },
  { family: "Aubrey", weights: ["400"] },
  { family: "Audiowide", weights: ["400"] },
  { family: "Autour One", weights: ["400"] },
  { family: "Average", weights: ["400"] },
  { family: "Average Sans", weights: ["400"] },
  { family: "Averia Gruesa Libre", weights: ["400"] },
  { family: "Averia Libre", weights: ["300", "400", "700", "300i", "400i", "700i"] },
  { family: "Averia Sans Libre", weights: ["300", "400", "700", "300i", "400i", "700i"] },
  { family: "Averia Serif Libre", weights: ["300", "400", "700", "300i", "400i", "700i"] },
  { family: "Azeret Mono", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900", "100i", "200i", "300i", "400i", "500i", "600i", "700i", "800i", "900i"] },
  { family: "B612", weights: ["400", "700", "400i", "700i"] },
  { family: "B612 Mono", weights: ["400", "700", "400i", "700i"] },
  { family: "Babylonica", weights: ["400"] },
  { family: "Bacasime Antique", weights: ["400"] },
  { family: "Bad Script", weights: ["400"] },
  { family: "Badeen Display", weights: ["400"] },
  { family: "Bagel Fat One", weights: ["400"] },
  { family: "Bahiana", weights: ["400"] },
  { family: "Bahianita", weights: ["400"] },
  { family: "Bai Jamjuree", weights: ["200", "300", "400", "500", "600", "700", "200i", "300i", "400i", "500i", "600i", "700i"] },
  { family: "Bakbak One", weights: ["400"] },
  { family: "Ballet", weights: ["400"] },
  { family: "Baloo 2", weights: ["400", "500", "600", "700", "800"] },
  { family: "Baloo Bhai 2", weights: ["400", "500", "600", "700", "800"] },
  { family: "Baloo Bhaijaan 2", weights: ["400", "500", "600", "700", "800"] },
  { family: "Baloo Bhaina 2", weights: ["400", "500", "600", "700", "800"] },
  { family: "Baloo Chettan 2", weights: ["400", "500", "600", "700", "800"] },
  { family: "Baloo Da 2", weights: ["400", "500", "600", "700", "800"] },
  { family: "Baloo Paaji 2", weights: ["400", "500", "600", "700", "800"] },
  { family: "Baloo Tamma 2", weights: ["400", "500", "600", "700", "800"] },
  { family: "Baloo Tammudu 2", weights: ["400", "500", "600", "700", "800"] },
  { family: "Baloo Thambi 2", weights: ["400", "500", "600", "700", "800"] },
  { family: "Balsamiq Sans", weights: ["400", "700", "400i", "700i"] },
  { family: "Balthazar", weights: ["400"] },
  { family: "Bangers", weights: ["400"] },
  { family: "Barlow", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900", "100i", "200i", "300i", "400i", "500i", "600i", "700i", "800i", "900i"] },
  { family: "Barlow Condensed", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900", "100i", "200i", "300i", "400i", "500i", "600i", "700i", "800i", "900i"] },
  { family: "Barlow Semi Condensed", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900", "100i", "200i", "300i", "400i", "500i", "600i", "700i", "800i", "900i"] },
  { family: "Barriecito", weights: ["400"] },
  { family: "Barrio", weights: ["400"] },
  { family: "Basic", weights: ["400"] },
  { family: "Baskervville", weights: ["400", "500", "600", "700", "400i", "500i", "600i", "700i"] },
  { family: "Baskervville SC", weights: ["400", "500", "600", "700"] },
  { family: "Battambang", weights: ["100", "300", "400", "700", "900"] },
  { family: "Baumans", weights: ["400"] },
  { family: "Bayon", weights: ["400"] },
  { family: "BBH Bartle", weights: ["400"] },
  { family: "BBH Bogle", weights: ["400"] },
  { family: "BBH Hegarty", weights: ["400"] },
  { family: "Be Vietnam Pro", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900", "100i", "200i", "300i", "400i", "500i", "600i", "700i", "800i", "900i"] },
  { family: "Beau Rivage", weights: ["400"] },
  { family: "Bebas Neue", weights: ["400"] },
  { family: "Beiruti", weights: ["200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Belanosima", weights: ["400", "600", "700"] },
  { family: "Belgrano", weights: ["400"] },
  { family: "Bellefair", weights: ["400"] },
  { family: "Belleza", weights: ["400"] },
  { family: "Bellota", weights: ["300", "400", "700", "300i", "400i", "700i"] },
  { family: "Bellota Text", weights: ["300", "400", "700", "300i", "400i", "700i"] },
  { family: "BenchNine", weights: ["300", "400", "700"] },
  { family: "Benne", weights: ["400"] },
  { family: "Bentham", weights: ["400"] },
  { family: "Berkshire Swash", weights: ["400"] },
  { family: "Besley", weights: ["400", "500", "600", "700", "800", "900", "400i", "500i", "600i", "700i", "800i", "900i"] },
  { family: "Betania Patmos", weights: ["400"] },
  { family: "Betania Patmos GDL", weights: ["400"] },
  { family: "Betania Patmos In", weights: ["400"] },
  { family: "Betania Patmos In GDL", weights: ["400"] },
  { family: "Beth Ellen", weights: ["400"] },
  { family: "Bevan", weights: ["400", "400i"] },
  { family: "BhuTuka Expanded One", weights: ["400"] },
  { family: "Big Shoulders", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Big Shoulders Inline", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Big Shoulders Stencil", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Bigelow Rules", weights: ["400"] },
  { family: "Bigshot One", weights: ["400"] },
  { family: "Bilbo", weights: ["400"] },
  { family: "Bilbo Swash Caps", weights: ["400"] },
  { family: "BioRhyme", weights: ["200", "300", "400", "500", "600", "700", "800"] },
  { family: "BioRhyme Expanded", weights: ["200", "300", "400", "700", "800"] },
  { family: "Birthstone", weights: ["400"] },
  { family: "Birthstone Bounce", weights: ["400", "500"] },
  { family: "Biryani", weights: ["200", "300", "400", "600", "700", "800", "900"] },
  { family: "Bitcount", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Bitcount Grid Double", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Bitcount Grid Double Ink", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Bitcount Grid Single", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Bitcount Grid Single Ink", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Bitcount Ink", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Bitcount Prop Double", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Bitcount Prop Double Ink", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Bitcount Prop Single", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Bitcount Prop Single Ink", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Bitcount Single", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Bitcount Single Ink", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Bitter", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900", "100i", "200i", "300i", "400i", "500i", "600i", "700i", "800i", "900i"] },
  { family: "BIZ UDGothic", weights: ["400", "700"] },
  { family: "BIZ UDMincho", weights: ["400", "700"] },
  { family: "BIZ UDPGothic", weights: ["400", "700"] },
  { family: "BIZ UDPMincho", weights: ["400", "700"] },
  { family: "BJCree", weights: ["400", "500", "600", "700"] },
  { family: "Black And White Picture", weights: ["400"] },
  { family: "Black Han Sans", weights: ["400"] },
  { family: "Black Ops One", weights: ["400"] },
  { family: "Blaka", weights: ["400"] },
  { family: "Blaka Hollow", weights: ["400"] },
  { family: "Blaka Ink", weights: ["400"] },
  { family: "Blinker", weights: ["100", "200", "300", "400", "600", "700", "800", "900"] },
  { family: "Bodoni Moda", weights: ["400", "500", "600", "700", "800", "900", "400i", "500i", "600i", "700i", "800i", "900i"] },
  { family: "Bodoni Moda SC", weights: ["400", "500", "600", "700", "800", "900", "400i", "500i", "600i", "700i", "800i", "900i"] },
  { family: "Bokor", weights: ["400"] },
  { family: "Boldonse", weights: ["400"] },
  { family: "Bona Nova", weights: ["400", "700", "400i"] },
  { family: "Bona Nova SC", weights: ["400", "700", "400i"] },
  { family: "Bonbon", weights: ["400"] },
  { family: "Bonheur Royale", weights: ["400"] },
  { family: "Boogaloo", weights: ["400"] },
  { family: "Borel", weights: ["400"] },
  { family: "Bowlby One", weights: ["400"] },
  { family: "Bowlby One SC", weights: ["400"] },
  { family: "Bpmf Huninn", weights: ["400"] },
  { family: "Bpmf Iansui", weights: ["400"] },
  { family: "Bpmf Zihi Kai Std", weights: ["400"] },
  { family: "Braah One", weights: ["400"] },
  { family: "Brawler", weights: ["400", "700"] },
  { family: "Bree Serif", weights: ["400"] },
  { family: "Bricolage Grotesque", weights: ["200", "300", "400", "500", "600", "700", "800"] },
  { family: "Bruno Ace", weights: ["400"] },
  { family: "Bruno Ace SC", weights: ["400"] },
  { family: "Brygada 1918", weights: ["400", "500", "600", "700", "400i", "500i", "600i", "700i"] },
  { family: "Bubblegum Sans", weights: ["400"] },
  { family: "Bubbler One", weights: ["400"] },
  { family: "Buda", weights: ["300"] },
  { family: "Buenard", weights: ["400", "500", "600", "700"] },
  { family: "Bungee", weights: ["400"] },
  { family: "Bungee Hairline", weights: ["400"] },
  { family: "Bungee Inline", weights: ["400"] },
  { family: "Bungee Outline", weights: ["400"] },
  { family: "Bungee Shade", weights: ["400"] },
  { family: "Bungee Spice", weights: ["400"] },
  { family: "Bungee Tint", weights: ["400"] },
  { family: "Butcherman", weights: ["400"] },
  { family: "Butterfly Kids", weights: ["400"] },
  { family: "Bytesized", weights: ["400"] },
  { family: "Cabin", weights: ["400", "500", "600", "700", "400i", "500i", "600i", "700i"] },
  { family: "Cabin Condensed", weights: ["400", "500", "600", "700"] },
  { family: "Cabin Sketch", weights: ["400", "700"] },
  { family: "Cactus Classical Serif", weights: ["400"] },
  { family: "Caesar Dressing", weights: ["400"] },
  { family: "Cagliostro", weights: ["400"] },
  { family: "Cairo", weights: ["200", "300", "400", "500", "600", "700", "800", "900", "1000"] },
  { family: "Cairo Play", weights: ["200", "300", "400", "500", "600", "700", "800", "900", "1000"] },
  { family: "Cal Sans", weights: ["400"] },
  { family: "Caladea", weights: ["400", "700", "400i", "700i"] },
  { family: "Calistoga", weights: ["400"] },
  { family: "Calligraffitti", weights: ["400"] },
  { family: "Cambay", weights: ["400", "700", "400i", "700i"] },
  { family: "Cambo", weights: ["400"] },
  { family: "Candal", weights: ["400"] },
  { family: "Cantarell", weights: ["400", "700", "400i", "700i"] },
  { family: "Cantata One", weights: ["400"] },
  { family: "Cantora One", weights: ["400"] },
  { family: "Caprasimo", weights: ["400"] },
  { family: "Capriola", weights: ["400"] },
  { family: "Caramel", weights: ["400"] },
  { family: "Carattere", weights: ["400"] },
  { family: "Cardo", weights: ["400", "700", "400i"] },
  { family: "Carlito", weights: ["400", "700", "400i", "700i"] },
  { family: "Carme", weights: ["400"] },
  { family: "Carrois Gothic", weights: ["400"] },
  { family: "Carrois Gothic SC", weights: ["400"] },
  { family: "Carter One", weights: ["400"] },
  { family: "Cascadia Code", weights: ["200", "300", "400", "500", "600", "700", "200i", "300i", "400i", "500i", "600i", "700i"] },
  { family: "Cascadia Mono", weights: ["200", "300", "400", "500", "600", "700", "200i", "300i", "400i", "500i", "600i", "700i"] },
  { family: "Castoro", weights: ["400", "400i"] },
  { family: "Castoro Titling", weights: ["400"] },
  { family: "Catamaran", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Caudex", weights: ["400", "700", "400i", "700i"] },
  { family: "Cause", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Caveat", weights: ["400", "500", "600", "700"] },
  { family: "Caveat Brush", weights: ["400"] },
  { family: "Cedarville Cursive", weights: ["400"] },
  { family: "Ceviche One", weights: ["400"] },
  { family: "Chakra Petch", weights: ["300", "400", "500", "600", "700", "300i", "400i", "500i", "600i", "700i"] },
  { family: "Changa", weights: ["200", "300", "400", "500", "600", "700", "800"] },
  { family: "Changa One", weights: ["400", "400i"] },
  { family: "Chango", weights: ["400"] },
  { family: "Charis SIL", weights: ["400", "700", "400i", "700i"] },
  { family: "Charm", weights: ["400", "700"] },
  { family: "Charmonman", weights: ["400", "700"] },
  { family: "Chathura", weights: ["100", "300", "400", "700", "800"] },
  { family: "Chau Philomene One", weights: ["400", "400i"] },
  { family: "Chela One", weights: ["400"] },
  { family: "Chelsea Market", weights: ["400"] },
  { family: "Chenla", weights: ["400"] },
  { family: "Cherish", weights: ["400"] },
  { family: "Cherry Bomb One", weights: ["400"] },
  { family: "Cherry Cream Soda", weights: ["400"] },
  { family: "Cherry Swash", weights: ["400", "700"] },
  { family: "Chewy", weights: ["400"] },
  { family: "Chicle", weights: ["400"] },
  { family: "Chilanka", weights: ["400"] },
  { family: "Chiron GoRound TC", weights: ["200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Chiron Hei HK", weights: ["200", "300", "400", "500", "600", "700", "800", "900", "200i", "300i", "400i", "500i", "600i", "700i", "800i", "900i"] },
  { family: "Chiron Sung HK", weights: ["200", "300", "400", "500", "600", "700", "800", "900", "200i", "300i", "400i", "500i", "600i", "700i", "800i", "900i"] },
  { family: "Chivo", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900", "100i", "200i", "300i", "400i", "500i", "600i", "700i", "800i", "900i"] },
  { family: "Chivo Mono", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900", "100i", "200i", "300i", "400i", "500i", "600i", "700i", "800i", "900i"] },
  { family: "Chocolate Classical Sans", weights: ["400"] },
  { family: "Chokokutai", weights: ["400"] },
  { family: "Chonburi", weights: ["400"] },
  { family: "Cinzel", weights: ["400", "500", "600", "700", "800", "900"] },
  { family: "Cinzel Decorative", weights: ["400", "700", "900"] },
  { family: "Clicker Script", weights: ["400"] },
  { family: "Climate Crisis", weights: ["400"] },
  { family: "Coda", weights: ["400", "800"] },
  { family: "Codystar", weights: ["300", "400"] },
  { family: "Coiny", weights: ["400"] },
  { family: "Combo", weights: ["400"] },
  { family: "Comfortaa", weights: ["300", "400", "500", "600", "700"] },
  { family: "Comforter", weights: ["400"] },
  { family: "Comforter Brush", weights: ["400"] },
  { family: "Comic Neue", weights: ["300", "400", "700", "300i", "400i", "700i"] },
  { family: "Comic Relief", weights: ["400", "700"] },
  { family: "Coming Soon", weights: ["400"] },
  { family: "Comme", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Commissioner", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Concert One", weights: ["400"] },
  { family: "Condiment", weights: ["400"] },
  { family: "Content", weights: ["400", "700"] },
  { family: "Contrail One", weights: ["400"] },
  { family: "Convergence", weights: ["400"] },
  { family: "Cookie", weights: ["400"] },
  { family: "Copse", weights: ["400"] },
  { family: "Coral Pixels", weights: ["400"] },
  { family: "Corben", weights: ["400", "700"] },
  { family: "Corinthia", weights: ["400", "700"] },
  { family: "Cormorant", weights: ["300", "400", "500", "600", "700", "300i", "400i", "500i", "600i", "700i"] },
  { family: "Cormorant Garamond", weights: ["300", "400", "500", "600", "700", "300i", "400i", "500i", "600i", "700i"] },
  { family: "Cormorant Infant", weights: ["300", "400", "500", "600", "700", "300i", "400i", "500i", "600i", "700i"] },
  { family: "Cormorant SC", weights: ["300", "400", "500", "600", "700"] },
  { family: "Cormorant Unicase", weights: ["300", "400", "500", "600", "700"] },
  { family: "Cormorant Upright", weights: ["300", "400", "500", "600", "700"] },
  { family: "Cossette Texte", weights: ["400", "700"] },
  { family: "Cossette Titre", weights: ["400", "700"] },
  { family: "Courgette", weights: ["400"] },
  { family: "Courier Prime", weights: ["400", "700", "400i", "700i"] },
  { family: "Cousine", weights: ["400", "700", "400i", "700i"] },
  { family: "Coustard", weights: ["400", "900"] },
  { family: "Covered By Your Grace", weights: ["400"] },
  { family: "Crafty Girls", weights: ["400"] },
  { family: "Creepster", weights: ["400"] },
  { family: "Crete Round", weights: ["400", "400i"] },
  { family: "Crimson Pro", weights: ["200", "300", "400", "500", "600", "700", "800", "900", "200i", "300i", "400i", "500i", "600i", "700i", "800i", "900i"] },
  { family: "Crimson Text", weights: ["400", "600", "700", "400i", "600i", "700i"] },
  { family: "Croissant One", weights: ["400"] },
  { family: "Crushed", weights: ["400"] },
  { family: "Cuprum", weights: ["400", "500", "600", "700", "400i", "500i", "600i", "700i"] },
  { family: "Cute Font", weights: ["400"] },
  { family: "Cutive", weights: ["400"] },
  { family: "Cutive Mono", weights: ["400"] },
  { family: "Dai Banna SIL", weights: ["300", "400", "500", "600", "700", "300i", "400i", "500i", "600i", "700i"] },
  { family: "Damion", weights: ["400"] },
  { family: "Dancing Script", weights: ["400", "500", "600", "700"] },
  { family: "Danfo", weights: ["400"] },
  { family: "Dangrek", weights: ["400"] },
  { family: "Darker Grotesque", weights: ["300", "400", "500", "600", "700", "800", "900"] },
  { family: "Darumadrop One", weights: ["400"] },
  { family: "Datatype", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "David Libre", weights: ["400", "500", "700"] },
  { family: "Dawning of a New Day", weights: ["400"] },
  { family: "Days One", weights: ["400"] },
  { family: "Dekko", weights: ["400"] },
  { family: "Dela Gothic One", weights: ["400"] },
  { family: "Delicious Handrawn", weights: ["400"] },
  { family: "Delius", weights: ["400"] },
  { family: "Delius Swash Caps", weights: ["400"] },
  { family: "Delius Unicase", weights: ["400", "700"] },
  { family: "Della Respira", weights: ["400"] },
  { family: "Denk One", weights: ["400"] },
  { family: "Devonshire", weights: ["400"] },
  { family: "Dhurjati", weights: ["400"] },
  { family: "Didact Gothic", weights: ["400"] },
  { family: "Diphylleia", weights: ["400"] },
  { family: "Diplomata", weights: ["400"] },
  { family: "Diplomata SC", weights: ["400"] },
  { family: "DM Mono", weights: ["300", "400", "500", "300i", "400i", "500i"] },
  { family: "DM Sans", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900", "1000", "1000i", "100i", "200i", "300i", "400i", "500i", "600i", "700i", "800i", "900i"] },
  { family: "DM Serif Display", weights: ["400", "400i"] },
  { family: "DM Serif Text", weights: ["400", "400i"] },
  { family: "Do Hyeon", weights: ["400"] },
  { family: "Dokdo", weights: ["400"] },
  { family: "Domine", weights: ["400", "500", "600", "700"] },
  { family: "Donegal One", weights: ["400"] },
  { family: "Dongle", weights: ["300", "400", "700"] },
  { family: "Doppio One", weights: ["400"] },
  { family: "Dorsa", weights: ["400"] },
  { family: "Dosis", weights: ["200", "300", "400", "500", "600", "700", "800"] },
  { family: "DotGothic16", weights: ["400"] },
  { family: "Doto", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Dr Sugiyama", weights: ["400"] },
  { family: "Duru Sans", weights: ["400"] },
  { family: "Dynalight", weights: ["400"] },
  { family: "DynaPuff", weights: ["400", "500", "600", "700"] },
  { family: "Eagle Lake", weights: ["400"] },
  { family: "East Sea Dokdo", weights: ["400"] },
  { family: "Eater", weights: ["400"] },
  { family: "EB Garamond", weights: ["400", "500", "600", "700", "800", "400i", "500i", "600i", "700i", "800i"] },
  { family: "Economica", weights: ["400", "700", "400i", "700i"] },
  { family: "Eczar", weights: ["400", "500", "600", "700", "800"] },
  { family: "Edu AU VIC WA NT Arrows", weights: ["400", "500", "600", "700"] },
  { family: "Edu AU VIC WA NT Dots", weights: ["400", "500", "600", "700"] },
  { family: "Edu AU VIC WA NT Guides", weights: ["400", "500", "600", "700"] },
  { family: "Edu AU VIC WA NT Hand", weights: ["400", "500", "600", "700"] },
  { family: "Edu AU VIC WA NT Pre", weights: ["400", "500", "600", "700"] },
  { family: "Edu NSW ACT Cursive", weights: ["400", "500", "600", "700"] },
  { family: "Edu NSW ACT Foundation", weights: ["400", "500", "600", "700"] },
  { family: "Edu NSW ACT Hand Pre", weights: ["400", "500", "600", "700"] },
  { family: "Edu QLD Beginner", weights: ["400", "500", "600", "700"] },
  { family: "Edu QLD Hand", weights: ["400", "500", "600", "700"] },
  { family: "Edu SA Beginner", weights: ["400", "500", "600", "700"] },
  { family: "Edu SA Hand", weights: ["400", "500", "600", "700"] },
  { family: "Edu TAS Beginner", weights: ["400", "500", "600", "700"] },
  { family: "Edu VIC WA NT Beginner", weights: ["400", "500", "600", "700"] },
  { family: "Edu VIC WA NT Hand", weights: ["400", "500", "600", "700"] },
  { family: "Edu VIC WA NT Hand Pre", weights: ["400", "500", "600", "700"] },
  { family: "El Messiri", weights: ["400", "500", "600", "700"] },
  { family: "Electrolize", weights: ["400"] },
  { family: "Elms Sans", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900", "100i", "200i", "300i", "400i", "500i", "600i", "700i", "800i", "900i"] },
  { family: "Elsie", weights: ["400", "900"] },
  { family: "Elsie Swash Caps", weights: ["400", "900"] },
  { family: "Emblema One", weights: ["400"] },
  { family: "Emilys Candy", weights: ["400"] },
  { family: "Encode Sans", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Encode Sans Condensed", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Encode Sans Expanded", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Encode Sans SC", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Encode Sans Semi Condensed", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Encode Sans Semi Expanded", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Engagement", weights: ["400"] },
  { family: "Englebert", weights: ["400"] },
  { family: "Enriqueta", weights: ["400", "500", "600", "700"] },
  { family: "Ephesis", weights: ["400"] },
  { family: "Epilogue", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900", "100i", "200i", "300i", "400i", "500i", "600i", "700i", "800i", "900i"] },
  { family: "Epunda Sans", weights: ["300", "400", "500", "600", "700", "800", "900", "300i", "400i", "500i", "600i", "700i", "800i", "900i"] },
  { family: "Epunda Slab", weights: ["300", "400", "500", "600", "700", "800", "900", "300i", "400i", "500i", "600i", "700i", "800i", "900i"] },
  { family: "Erica One", weights: ["400"] },
  { family: "Esteban", weights: ["400"] },
  { family: "Estedad", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Estonia", weights: ["400"] },
  { family: "Euphoria Script", weights: ["400"] },
  { family: "Ewert", weights: ["400"] },
  { family: "Exile", weights: ["400"] },
  { family: "Exo", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900", "100i", "200i", "300i", "400i", "500i", "600i", "700i", "800i", "900i"] },
  { family: "Exo 2", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900", "100i", "200i", "300i", "400i", "500i", "600i", "700i", "800i", "900i"] },
  { family: "Expletus Sans", weights: ["400", "500", "600", "700", "400i", "500i", "600i", "700i"] },
  { family: "Explora", weights: ["400"] },
  { family: "Faculty Glyphic", weights: ["400"] },
  { family: "Fahkwang", weights: ["200", "300", "400", "500", "600", "700", "200i", "300i", "400i", "500i", "600i", "700i"] },
  { family: "Familjen Grotesk", weights: ["400", "500", "600", "700", "400i", "500i", "600i", "700i"] },
  { family: "Fanwood Text", weights: ["400", "400i"] },
  { family: "Farro", weights: ["300", "400", "500", "700"] },
  { family: "Farsan", weights: ["400"] },
  { family: "Fascinate", weights: ["400"] },
  { family: "Fascinate Inline", weights: ["400"] },
  { family: "Faster One", weights: ["400"] },
  { family: "Fasthand", weights: ["400"] },
  { family: "Fauna One", weights: ["400"] },
  { family: "Faustina", weights: ["300", "400", "500", "600", "700", "800", "300i", "400i", "500i", "600i", "700i", "800i"] },
  { family: "Federant", weights: ["400"] },
  { family: "Federo", weights: ["400"] },
  { family: "Felipa", weights: ["400"] },
  { family: "Fenix", weights: ["400"] },
  { family: "Festive", weights: ["400"] },
  { family: "Figtree", weights: ["300", "400", "500", "600", "700", "800", "900", "300i", "400i", "500i", "600i", "700i", "800i", "900i"] },
  { family: "Finger Paint", weights: ["400"] },
  { family: "Finlandica Headline", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900", "100i", "200i", "300i", "400i", "500i", "600i", "700i", "800i", "900i"] },
  { family: "Finlandica Text", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900", "100i", "200i", "300i", "400i", "500i", "600i", "700i", "800i", "900i"] },
  { family: "Fira Code", weights: ["300", "400", "500", "600", "700"] },
  { family: "Fira Mono", weights: ["400", "500", "700"] },
  { family: "Fira Sans", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900", "100i", "200i", "300i", "400i", "500i", "600i", "700i", "800i", "900i"] },
  { family: "Fira Sans Condensed", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900", "100i", "200i", "300i", "400i", "500i", "600i", "700i", "800i", "900i"] },
  { family: "Fira Sans Extra Condensed", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900", "100i", "200i", "300i", "400i", "500i", "600i", "700i", "800i", "900i"] },
  { family: "Fjalla One", weights: ["400"] },
  { family: "Fjord One", weights: ["400"] },
  { family: "Flamenco", weights: ["300", "400"] },
  { family: "Flavors", weights: ["400"] },
  { family: "Fleur De Leah", weights: ["400"] },
  { family: "Flow Block", weights: ["400"] },
  { family: "Flow Circular", weights: ["400"] },
  { family: "Flow Rounded", weights: ["400"] },
  { family: "Foldit", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Fondamento", weights: ["400", "400i"] },
  { family: "Fontdiner Swanky", weights: ["400"] },
  { family: "Forum", weights: ["400"] },
  { family: "Fragment Mono", weights: ["400", "400i"] },
  { family: "Francois One", weights: ["400"] },
  { family: "Frank Ruhl Libre", weights: ["300", "400", "500", "600", "700", "800", "900"] },
  { family: "Fraunces", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900", "100i", "200i", "300i", "400i", "500i", "600i", "700i", "800i", "900i"] },
  { family: "Freckle Face", weights: ["400"] },
  { family: "Fredericka the Great", weights: ["400"] },
  { family: "Fredoka", weights: ["300", "400", "500", "600", "700"] },
  { family: "Freehand", weights: ["400"] },
  { family: "Freeman", weights: ["400"] },
  { family: "Fresca", weights: ["400"] },
  { family: "Frijole", weights: ["400"] },
  { family: "Fruktur", weights: ["400", "400i"] },
  { family: "Fugaz One", weights: ["400"] },
  { family: "Fuggles", weights: ["400"] },
  { family: "Funnel Display", weights: ["300", "400", "500", "600", "700", "800"] },
  { family: "Funnel Sans", weights: ["300", "400", "500", "600", "700", "800", "300i", "400i", "500i", "600i", "700i", "800i"] },
  { family: "Fustat", weights: ["200", "300", "400", "500", "600", "700", "800"] },
  { family: "Fuzzy Bubbles", weights: ["400", "700"] },
  { family: "Ga Maamli", weights: ["400"] },
  { family: "Gabarito", weights: ["400", "500", "600", "700", "800", "900"] },
  { family: "Gabriela", weights: ["400"] },
  { family: "Gaegu", weights: ["300", "400", "700"] },
  { family: "Gafata", weights: ["400"] },
  { family: "Gajraj One", weights: ["400"] },
  { family: "Galada", weights: ["400"] },
  { family: "Galdeano", weights: ["400"] },
  { family: "Galindo", weights: ["400"] },
  { family: "Gamja Flower", weights: ["400"] },
  { family: "Gantari", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900", "100i", "200i", "300i", "400i", "500i", "600i", "700i", "800i", "900i"] },
  { family: "Gasoek One", weights: ["400"] },
  { family: "Gayathri", weights: ["100", "400", "700"] },
  { family: "Geist", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900", "100i", "200i", "300i", "400i", "500i", "600i", "700i", "800i", "900i"] },
  { family: "Geist Mono", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900", "100i", "200i", "300i", "400i", "500i", "600i", "700i", "800i", "900i"] },
  { family: "Geist Pixel", weights: ["400"] },
  { family: "Gelasio", weights: ["400", "500", "600", "700", "400i", "500i", "600i", "700i"] },
  { family: "Gemunu Libre", weights: ["200", "300", "400", "500", "600", "700", "800"] },
  { family: "Genos", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900", "100i", "200i", "300i", "400i", "500i", "600i", "700i", "800i", "900i"] },
  { family: "Gentium Book Plus", weights: ["400", "700", "400i", "700i"] },
  { family: "Gentium Plus", weights: ["400", "700", "400i", "700i"] },
  { family: "Geo", weights: ["400", "400i"] },
  { family: "Geologica", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Geom", weights: ["300", "400", "500", "600", "700", "800", "900", "300i", "400i", "500i", "600i", "700i", "800i", "900i"] },
  { family: "Geomini", weights: ["200", "300", "400", "500", "600", "700", "800"] },
  { family: "Georama", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900", "100i", "200i", "300i", "400i", "500i", "600i", "700i", "800i", "900i"] },
  { family: "Geostar", weights: ["400"] },
  { family: "Geostar Fill", weights: ["400"] },
  { family: "Germania One", weights: ["400"] },
  { family: "GFS Didot", weights: ["400"] },
  { family: "GFS Neohellenic", weights: ["400", "700", "400i", "700i"] },
  { family: "Gideon Roman", weights: ["400"] },
  { family: "Gidole", weights: ["400"] },
  { family: "Gidugu", weights: ["400"] },
  { family: "Gilda Display", weights: ["400"] },
  { family: "Girassol", weights: ["400"] },
  { family: "Give You Glory", weights: ["400"] },
  { family: "Glass Antiqua", weights: ["400"] },
  { family: "Glegoo", weights: ["400", "700"] },
  { family: "Gloock", weights: ["400"] },
  { family: "Gloria Hallelujah", weights: ["400"] },
  { family: "Glory", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "100i", "200i", "300i", "400i", "500i", "600i", "700i", "800i"] },
  { family: "Gluten", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Goblin One", weights: ["400"] },
  { family: "Gochi Hand", weights: ["400"] },
  { family: "Goldman", weights: ["400", "700"] },
  { family: "Golos Text", weights: ["400", "500", "600", "700", "800", "900"] },
  { family: "Google Sans", weights: ["400", "500", "600", "700", "400i", "500i", "600i", "700i"] },
  { family: "Google Sans Code", weights: ["300", "400", "500", "600", "700", "800", "300i", "400i", "500i", "600i", "700i", "800i"] },
  { family: "Google Sans Flex", weights: ["1", "100", "200", "300", "400", "500", "600", "700", "800", "900", "1000"] },
  { family: "Gorditas", weights: ["400", "700"] },
  { family: "Gothic A1", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Gotu", weights: ["400"] },
  { family: "Goudy Bookletter 1911", weights: ["400"] },
  { family: "Gowun Batang", weights: ["400", "700"] },
  { family: "Gowun Dodum", weights: ["400"] },
  { family: "Graduate", weights: ["400"] },
  { family: "Grand Hotel", weights: ["400"] },
  { family: "Grandiflora One", weights: ["400"] },
  { family: "Grandstander", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900", "100i", "200i", "300i", "400i", "500i", "600i", "700i", "800i", "900i"] },
  { family: "Grape Nuts", weights: ["400"] },
  { family: "Gravitas One", weights: ["400"] },
  { family: "Great Vibes", weights: ["400"] },
  { family: "Grechen Fuemen", weights: ["400"] },
  { family: "Grenze", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900", "100i", "200i", "300i", "400i", "500i", "600i", "700i", "800i", "900i"] },
  { family: "Grenze Gotisch", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Grey Qo", weights: ["400"] },
  { family: "Griffy", weights: ["400"] },
  { family: "Gruppo", weights: ["400"] },
  { family: "Gudea", weights: ["400", "700", "400i"] },
  { family: "Gugi", weights: ["400"] },
  { family: "Gulzar", weights: ["400"] },
  { family: "Gupter", weights: ["400", "500", "700"] },
  { family: "Gurajada", weights: ["400"] },
  { family: "Gveret Levin", weights: ["400"] },
  { family: "Gwendolyn", weights: ["400", "700"] },
  { family: "Habibi", weights: ["400"] },
  { family: "Hachi Maru Pop", weights: ["400"] },
  { family: "Hahmlet", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Halant", weights: ["300", "400", "500", "600", "700"] },
  { family: "Hammersmith One", weights: ["400"] },
  { family: "Hanalei", weights: ["400"] },
  { family: "Hanalei Fill", weights: ["400"] },
  { family: "Handjet", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Handlee", weights: ["400"] },
  { family: "Hanken Grotesk", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900", "100i", "200i", "300i", "400i", "500i", "600i", "700i", "800i", "900i"] },
  { family: "Hanuman", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Happy Monkey", weights: ["400"] },
  { family: "Harmattan", weights: ["400", "500", "600", "700"] },
  { family: "Headland One", weights: ["400"] },
  { family: "Hedvig Letters Sans", weights: ["400"] },
  { family: "Hedvig Letters Serif", weights: ["400"] },
  { family: "Heebo", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Henny Penny", weights: ["400"] },
  { family: "Hepta Slab", weights: ["1", "100", "200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Herr Von Muellerhoff", weights: ["400"] },
  { family: "Hi Melody", weights: ["400"] },
  { family: "Hibur Mono", weights: ["400"] },
  { family: "Hina Mincho", weights: ["400"] },
  { family: "Hind", weights: ["300", "400", "500", "600", "700"] },
  { family: "Hind Guntur", weights: ["300", "400", "500", "600", "700"] },
  { family: "Hind Madurai", weights: ["300", "400", "500", "600", "700"] },
  { family: "Hind Mysuru", weights: ["300", "400", "500", "600", "700"] },
  { family: "Hind Siliguri", weights: ["300", "400", "500", "600", "700"] },
  { family: "Hind Vadodara", weights: ["300", "400", "500", "600", "700"] },
  { family: "Holtwood One SC", weights: ["400"] },
  { family: "Homemade Apple", weights: ["400"] },
  { family: "Homenaje", weights: ["400"] },
  { family: "Honk", weights: ["400"] },
  { family: "Host Grotesk", weights: ["300", "400", "500", "600", "700", "800", "300i", "400i", "500i", "600i", "700i", "800i"] },
  { family: "Hubballi", weights: ["400"] },
  { family: "Hubot Sans", weights: ["200", "300", "400", "500", "600", "700", "800", "900", "200i", "300i", "400i", "500i", "600i", "700i", "800i", "900i"] },
  { family: "Huninn", weights: ["400"] },
  { family: "Hurricane", weights: ["400"] },
  { family: "Iansui", weights: ["400"] },
  { family: "Ibarra Real Nova", weights: ["400", "500", "600", "700", "400i", "500i", "600i", "700i"] },
  { family: "IBM Plex Mono", weights: ["100", "200", "300", "400", "500", "600", "700", "100i", "200i", "300i", "400i", "500i", "600i", "700i"] },
  { family: "IBM Plex Sans", weights: ["100", "200", "300", "400", "500", "600", "700", "100i", "200i", "300i", "400i", "500i", "600i", "700i"] },
  { family: "IBM Plex Sans Arabic", weights: ["100", "200", "300", "400", "500", "600", "700"] },
  { family: "IBM Plex Sans Condensed", weights: ["100", "200", "300", "400", "500", "600", "700", "100i", "200i", "300i", "400i", "500i", "600i", "700i"] },
  { family: "IBM Plex Sans Devanagari", weights: ["100", "200", "300", "400", "500", "600", "700"] },
  { family: "IBM Plex Sans Hebrew", weights: ["100", "200", "300", "400", "500", "600", "700"] },
  { family: "IBM Plex Sans JP", weights: ["100", "200", "300", "400", "500", "600", "700"] },
  { family: "IBM Plex Sans KR", weights: ["100", "200", "300", "400", "500", "600", "700"] },
  { family: "IBM Plex Sans Thai", weights: ["100", "200", "300", "400", "500", "600", "700"] },
  { family: "IBM Plex Sans Thai Looped", weights: ["100", "200", "300", "400", "500", "600", "700"] },
  { family: "IBM Plex Serif", weights: ["100", "200", "300", "400", "500", "600", "700", "100i", "200i", "300i", "400i", "500i", "600i", "700i"] },
  { family: "Iceberg", weights: ["400"] },
  { family: "Iceland", weights: ["400"] },
  { family: "Idiqlat", weights: ["200", "300", "400"] },
  { family: "IM Fell Double Pica", weights: ["400", "400i"] },
  { family: "IM Fell Double Pica SC", weights: ["400"] },
  { family: "IM Fell DW Pica", weights: ["400", "400i"] },
  { family: "IM Fell DW Pica SC", weights: ["400"] },
  { family: "IM Fell English", weights: ["400", "400i"] },
  { family: "IM Fell English SC", weights: ["400"] },
  { family: "IM Fell French Canon", weights: ["400", "400i"] },
  { family: "IM Fell French Canon SC", weights: ["400"] },
  { family: "IM Fell Great Primer", weights: ["400", "400i"] },
  { family: "IM Fell Great Primer SC", weights: ["400"] },
  { family: "Imbue", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Imperial Script", weights: ["400"] },
  { family: "Imprima", weights: ["400"] },
  { family: "Inclusive Sans", weights: ["300", "400", "500", "600", "700", "300i", "400i", "500i", "600i", "700i"] },
  { family: "Inconsolata", weights: ["200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Inder", weights: ["400"] },
  { family: "Indie Flower", weights: ["400"] },
  { family: "Ingrid Darling", weights: ["400"] },
  { family: "Inika", weights: ["400", "700"] },
  { family: "Inknut Antiqua", weights: ["300", "400", "500", "600", "700", "800", "900"] },
  { family: "Inria Sans", weights: ["300", "400", "700", "300i", "400i", "700i"] },
  { family: "Inria Serif", weights: ["300", "400", "700", "300i", "400i", "700i"] },
  { family: "Inspiration", weights: ["400"] },
  { family: "Instrument Sans", weights: ["400", "500", "600", "700", "400i", "500i", "600i", "700i"] },
  { family: "Instrument Serif", weights: ["400", "400i"] },
  { family: "Intel One Mono", weights: ["300", "400", "500", "600", "700", "300i", "400i", "500i", "600i", "700i"] },
  { family: "Inter", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900", "100i", "200i", "300i", "400i", "500i", "600i", "700i", "800i", "900i"] },
  { family: "Inter Tight", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900", "100i", "200i", "300i", "400i", "500i", "600i", "700i", "800i", "900i"] },
  { family: "Iosevka Charon", weights: ["300", "400", "500", "700", "300i", "400i", "500i", "700i"] },
  { family: "Iosevka Charon Mono", weights: ["300", "400", "500", "700", "300i", "400i", "500i", "700i"] },
  { family: "Irish Grover", weights: ["400"] },
  { family: "Island Moments", weights: ["400"] },
  { family: "Istok Web", weights: ["400", "700", "400i", "700i"] },
  { family: "Italiana", weights: ["400"] },
  { family: "Italianno", weights: ["400"] },
  { family: "Itim", weights: ["400"] },
  { family: "Jacquard 12", weights: ["400"] },
  { family: "Jacquard 12 Charted", weights: ["400"] },
  { family: "Jacquard 24", weights: ["400"] },
  { family: "Jacquard 24 Charted", weights: ["400"] },
  { family: "Jacquarda Bastarda 9", weights: ["400"] },
  { family: "Jacquarda Bastarda 9 Charted", weights: ["400"] },
  { family: "Jacques Francois", weights: ["400"] },
  { family: "Jacques Francois Shadow", weights: ["400"] },
  { family: "Jaini", weights: ["400"] },
  { family: "Jaini Purva", weights: ["400"] },
  { family: "Jaldi", weights: ["400", "700"] },
  { family: "Jaro", weights: ["400"] },
  { family: "Jersey 10", weights: ["400"] },
  { family: "Jersey 10 Charted", weights: ["400"] },
  { family: "Jersey 15", weights: ["400"] },
  { family: "Jersey 15 Charted", weights: ["400"] },
  { family: "Jersey 20", weights: ["400"] },
  { family: "Jersey 20 Charted", weights: ["400"] },
  { family: "Jersey 25", weights: ["400"] },
  { family: "Jersey 25 Charted", weights: ["400"] },
  { family: "JetBrains Mono", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "100i", "200i", "300i", "400i", "500i", "600i", "700i", "800i"] },
  { family: "Jim Nightshade", weights: ["400"] },
  { family: "Joan", weights: ["400"] },
  { family: "Jockey One", weights: ["400"] },
  { family: "Jolly Lodger", weights: ["400"] },
  { family: "Jomhuria", weights: ["400"] },
  { family: "Jomolhari", weights: ["400"] },
  { family: "Josefin Sans", weights: ["100", "200", "300", "400", "500", "600", "700", "100i", "200i", "300i", "400i", "500i", "600i", "700i"] },
  { family: "Josefin Slab", weights: ["100", "200", "300", "400", "500", "600", "700", "100i", "200i", "300i", "400i", "500i", "600i", "700i"] },
  { family: "Jost", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900", "100i", "200i", "300i", "400i", "500i", "600i", "700i", "800i", "900i"] },
  { family: "Joti One", weights: ["400"] },
  { family: "Jua", weights: ["400"] },
  { family: "Judson", weights: ["400", "700", "400i"] },
  { family: "Julee", weights: ["400"] },
  { family: "Julius Sans One", weights: ["400"] },
  { family: "Junge", weights: ["400"] },
  { family: "Jura", weights: ["300", "400", "500", "600", "700"] },
  { family: "Just Another Hand", weights: ["400"] },
  { family: "Just Me Again Down Here", weights: ["400"] },
  { family: "K2D", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "100i", "200i", "300i", "400i", "500i", "600i", "700i", "800i"] },
  { family: "Kablammo", weights: ["400"] },
  { family: "Kadwa", weights: ["400", "700"] },
  { family: "Kaisei Decol", weights: ["400", "500", "700"] },
  { family: "Kaisei HarunoUmi", weights: ["400", "500", "700"] },
  { family: "Kaisei Opti", weights: ["400", "500", "700"] },
  { family: "Kaisei Tokumin", weights: ["400", "500", "700", "800"] },
  { family: "Kalam", weights: ["300", "400", "700"] },
  { family: "Kalnia", weights: ["100", "200", "300", "400", "500", "600", "700"] },
  { family: "Kalnia Glaze", weights: ["100", "200", "300", "400", "500", "600", "700"] },
  { family: "Kameron", weights: ["400", "500", "600", "700"] },
  { family: "Kanchenjunga", weights: ["400", "500", "600", "700"] },
  { family: "Kanit", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900", "100i", "200i", "300i", "400i", "500i", "600i", "700i", "800i", "900i"] },
  { family: "Kantumruy Pro", weights: ["100", "200", "300", "400", "500", "600", "700", "100i", "200i", "300i", "400i", "500i", "600i", "700i"] },
  { family: "Kapakana", weights: ["300", "400"] },
  { family: "Karantina", weights: ["300", "400", "700"] },
  { family: "Karla", weights: ["200", "300", "400", "500", "600", "700", "800", "200i", "300i", "400i", "500i", "600i", "700i", "800i"] },
  { family: "Karla Tamil Inclined", weights: ["400", "700"] },
  { family: "Karla Tamil Upright", weights: ["400", "700"] },
  { family: "Karma", weights: ["300", "400", "500", "600", "700"] },
  { family: "Katibeh", weights: ["400"] },
  { family: "Kaushan Script", weights: ["400"] },
  { family: "Kavivanar", weights: ["400"] },
  { family: "Kavoon", weights: ["400"] },
  { family: "Kay Pho Du", weights: ["400", "500", "600", "700"] },
  { family: "Kdam Thmor Pro", weights: ["400"] },
  { family: "Keania One", weights: ["400"] },
  { family: "Kedebideri", weights: ["400", "500", "600", "700", "800", "900"] },
  { family: "Kelly Slab", weights: ["400"] },
  { family: "Kenia", weights: ["400"] },
  { family: "Khand", weights: ["300", "400", "500", "600", "700"] },
  { family: "Khmer", weights: ["400"] },
  { family: "Khula", weights: ["300", "400", "600", "700", "800"] },
  { family: "Kings", weights: ["400"] },
  { family: "Kirang Haerang", weights: ["400"] },
  { family: "Kite One", weights: ["400"] },
  { family: "Kiwi Maru", weights: ["300", "400", "500"] },
  { family: "Klee One", weights: ["400", "600"] },
  { family: "Knewave", weights: ["400"] },
  { family: "Kodchasan", weights: ["200", "300", "400", "500", "600", "700", "200i", "300i", "400i", "500i", "600i", "700i"] },
  { family: "Kode Mono", weights: ["400", "500", "600", "700"] },
  { family: "Koh Santepheap", weights: ["100", "300", "400", "700", "900"] },
  { family: "KoHo", weights: ["200", "300", "400", "500", "600", "700", "200i", "300i", "400i", "500i", "600i", "700i"] },
  { family: "Kolker Brush", weights: ["400"] },
  { family: "Konkhmer Sleokchher", weights: ["400"] },
  { family: "Kosugi", weights: ["400"] },
  { family: "Kosugi Maru", weights: ["400"] },
  { family: "Kotta One", weights: ["400"] },
  { family: "Koulen", weights: ["400"] },
  { family: "Kranky", weights: ["400"] },
  { family: "Kreon", weights: ["300", "400", "500", "600", "700"] },
  { family: "Kristi", weights: ["400"] },
  { family: "Krona One", weights: ["400"] },
  { family: "Krub", weights: ["200", "300", "400", "500", "600", "700", "200i", "300i", "400i", "500i", "600i", "700i"] },
  { family: "Kufam", weights: ["400", "500", "600", "700", "800", "900", "400i", "500i", "600i", "700i", "800i", "900i"] },
  { family: "Kulim Park", weights: ["200", "300", "400", "600", "700", "200i", "300i", "400i", "600i", "700i"] },
  { family: "Kumar One", weights: ["400"] },
  { family: "Kumar One Outline", weights: ["400"] },
  { family: "Kumbh Sans", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Kurale", weights: ["400"] },
  { family: "La Belle Aurore", weights: ["400"] },
  { family: "Labrada", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900", "100i", "200i", "300i", "400i", "500i", "600i", "700i", "800i", "900i"] },
  { family: "Lacquer", weights: ["400"] },
  { family: "Laila", weights: ["300", "400", "500", "600", "700"] },
  { family: "Lakki Reddy", weights: ["400"] },
  { family: "Lalezar", weights: ["400"] },
  { family: "Lancelot", weights: ["400"] },
  { family: "Langar", weights: ["400"] },
  { family: "Lateef", weights: ["200", "300", "400", "500", "600", "700", "800"] },
  { family: "Lato", weights: ["100", "300", "400", "700", "900", "100i", "300i", "400i", "700i", "900i"] },
  { family: "Lavishly Yours", weights: ["400"] },
  { family: "League Gothic", weights: ["400"] },
  { family: "League Script", weights: ["400"] },
  { family: "League Spartan", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Leckerli One", weights: ["400"] },
  { family: "Ledger", weights: ["400"] },
  { family: "Lekton", weights: ["400", "700", "400i"] },
  { family: "Lemon", weights: ["400"] },
  { family: "Lemonada", weights: ["300", "400", "500", "600", "700"] },
  { family: "Lexend", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Lexend Deca", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Lexend Exa", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Lexend Giga", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Lexend Mega", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Lexend Peta", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Lexend Tera", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Lexend Zetta", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Libertinus Keyboard", weights: ["400"] },
  { family: "Libertinus Math", weights: ["400"] },
  { family: "Libertinus Mono", weights: ["400"] },
  { family: "Libertinus Sans", weights: ["400", "700", "400i"] },
  { family: "Libertinus Serif", weights: ["400", "600", "700", "400i", "600i", "700i"] },
  { family: "Libertinus Serif Display", weights: ["400"] },
  { family: "Libre Barcode 128", weights: ["400"] },
  { family: "Libre Barcode 128 Text", weights: ["400"] },
  { family: "Libre Barcode 39", weights: ["400"] },
  { family: "Libre Barcode 39 Extended", weights: ["400"] },
  { family: "Libre Barcode 39 Extended Text", weights: ["400"] },
  { family: "Libre Barcode 39 Text", weights: ["400"] },
  { family: "Libre Barcode EAN13 Text", weights: ["400"] },
  { family: "Libre Baskerville", weights: ["400", "500", "600", "700", "400i", "500i", "600i", "700i"] },
  { family: "Libre Bodoni", weights: ["400", "500", "600", "700", "400i", "500i", "600i", "700i"] },
  { family: "Libre Caslon Display", weights: ["400"] },
  { family: "Libre Caslon Text", weights: ["400", "700", "400i"] },
  { family: "Libre Franklin", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900", "100i", "200i", "300i", "400i", "500i", "600i", "700i", "800i", "900i"] },
  { family: "Licorice", weights: ["400"] },
  { family: "Life Savers", weights: ["400", "700", "800"] },
  { family: "Lilex", weights: ["100", "200", "300", "400", "500", "600", "700", "100i", "200i", "300i", "400i", "500i", "600i", "700i"] },
  { family: "Lilita One", weights: ["400"] },
  { family: "Lily Script One", weights: ["400"] },
  { family: "Limelight", weights: ["400"] },
  { family: "Linden Hill", weights: ["400", "400i"] },
  { family: "LINE Seed JP", weights: ["100", "400", "700", "800"] },
  { family: "Linefont", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900", "1000"] },
  { family: "Lisu Bosa", weights: ["200", "300", "400", "500", "600", "700", "800", "900", "200i", "300i", "400i", "500i", "600i", "700i", "800i", "900i"] },
  { family: "Liter", weights: ["400"] },
  { family: "Literata", weights: ["200", "300", "400", "500", "600", "700", "800", "900", "200i", "300i", "400i", "500i", "600i", "700i", "800i", "900i"] },
  { family: "Liu Jian Mao Cao", weights: ["400"] },
  { family: "Livvic", weights: ["100", "200", "300", "400", "500", "600", "700", "900", "100i", "200i", "300i", "400i", "500i", "600i", "700i", "900i"] },
  { family: "Lobster", weights: ["400"] },
  { family: "Lobster Two", weights: ["400", "700", "400i", "700i"] },
  { family: "Londrina Outline", weights: ["400"] },
  { family: "Londrina Shadow", weights: ["400"] },
  { family: "Londrina Sketch", weights: ["400"] },
  { family: "Londrina Solid", weights: ["100", "300", "400", "900"] },
  { family: "Long Cang", weights: ["400"] },
  { family: "Lora", weights: ["400", "500", "600", "700", "400i", "500i", "600i", "700i"] },
  { family: "Love Light", weights: ["400"] },
  { family: "Love Ya Like A Sister", weights: ["400"] },
  { family: "Loved by the King", weights: ["400"] },
  { family: "Lovers Quarrel", weights: ["400"] },
  { family: "Luckiest Guy", weights: ["400"] },
  { family: "Lugrasimo", weights: ["400"] },
  { family: "Lumanosimo", weights: ["400"] },
  { family: "Lunasima", weights: ["400", "700"] },
  { family: "Lusitana", weights: ["400", "700"] },
  { family: "Lustria", weights: ["400"] },
  { family: "Luxurious Roman", weights: ["400"] },
  { family: "Luxurious Script", weights: ["400"] },
  { family: "LXGW Marker Gothic", weights: ["400"] },
  { family: "LXGW WenKai Mono TC", weights: ["300", "400", "700"] },
  { family: "LXGW WenKai TC", weights: ["300", "400", "700"] },
  { family: "M PLUS 1", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "M PLUS 1 Code", weights: ["100", "200", "300", "400", "500", "600", "700"] },
  { family: "M PLUS 1p", weights: ["100", "300", "400", "500", "700", "800", "900"] },
  { family: "M PLUS 2", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "M PLUS Code Latin", weights: ["100", "200", "300", "400", "500", "600", "700"] },
  { family: "M PLUS Rounded 1c", weights: ["100", "300", "400", "500", "700", "800", "900"] },
  { family: "M PLUS U", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Ma Shan Zheng", weights: ["400"] },
  { family: "Macondo", weights: ["400"] },
  { family: "Macondo Swash Caps", weights: ["400"] },
  { family: "Mada", weights: ["200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Madimi One", weights: ["400"] },
  { family: "Magra", weights: ["400", "700"] },
  { family: "Maiden Orange", weights: ["400"] },
  { family: "Maitree", weights: ["200", "300", "400", "500", "600", "700"] },
  { family: "Major Mono Display", weights: ["400"] },
  { family: "Mako", weights: ["400"] },
  { family: "Mali", weights: ["200", "300", "400", "500", "600", "700", "200i", "300i", "400i", "500i", "600i", "700i"] },
  { family: "Mallanna", weights: ["400"] },
  { family: "Maname", weights: ["400"] },
  { family: "Mandali", weights: ["400"] },
  { family: "Manjari", weights: ["100", "400", "700"] },
  { family: "Manrope", weights: ["200", "300", "400", "500", "600", "700", "800"] },
  { family: "Mansalva", weights: ["400"] },
  { family: "Manuale", weights: ["300", "400", "500", "600", "700", "800", "300i", "400i", "500i", "600i", "700i", "800i"] },
  { family: "Manufacturing Consent", weights: ["400"] },
  { family: "Marcellus", weights: ["400"] },
  { family: "Marcellus SC", weights: ["400"] },
  { family: "Marck Script", weights: ["400"] },
  { family: "Margarine", weights: ["400"] },
  { family: "Marhey", weights: ["300", "400", "500", "600", "700"] },
  { family: "Markazi Text", weights: ["400", "500", "600", "700"] },
  { family: "Marko One", weights: ["400"] },
  { family: "Marmelad", weights: ["400"] },
  { family: "Martel", weights: ["200", "300", "400", "600", "700", "800", "900"] },
  { family: "Martel Sans", weights: ["200", "300", "400", "600", "700", "800", "900"] },
  { family: "Martian Mono", weights: ["100", "200", "300", "400", "500", "600", "700", "800"] },
  { family: "Marvel", weights: ["400", "700", "400i", "700i"] },
  { family: "Matangi", weights: ["300", "400", "500", "600", "700", "800", "900"] },
  { family: "Mate", weights: ["400", "400i"] },
  { family: "Mate SC", weights: ["400"] },
  { family: "Matemasie", weights: ["400"] },
  { family: "Maven Pro", weights: ["400", "500", "600", "700", "800", "900"] },
  { family: "McLaren", weights: ["400"] },
  { family: "Mea Culpa", weights: ["400"] },
  { family: "Meddon", weights: ["400"] },
  { family: "MedievalSharp", weights: ["400"] },
  { family: "Medula One", weights: ["400"] },
  { family: "Meera Inimai", weights: ["400"] },
  { family: "Megrim", weights: ["400"] },
  { family: "Meie Script", weights: ["400"] },
  { family: "Menbere", weights: ["100", "200", "300", "400", "500", "600", "700"] },
  { family: "Meow Script", weights: ["400"] },
  { family: "Merienda", weights: ["300", "400", "500", "600", "700", "800", "900"] },
  { family: "Merriweather", weights: ["300", "400", "500", "600", "700", "800", "900", "300i", "400i", "500i", "600i", "700i", "800i", "900i"] },
  { family: "Merriweather Sans", weights: ["300", "400", "500", "600", "700", "800", "300i", "400i", "500i", "600i", "700i", "800i"] },
  { family: "Metal", weights: ["400"] },
  { family: "Metal Mania", weights: ["400"] },
  { family: "Metamorphous", weights: ["400"] },
  { family: "Metrophobic", weights: ["400"] },
  { family: "Michroma", weights: ["400"] },
  { family: "Micro 5", weights: ["400"] },
  { family: "Micro 5 Charted", weights: ["400"] },
  { family: "Milonga", weights: ["400"] },
  { family: "Miltonian", weights: ["400"] },
  { family: "Miltonian Tattoo", weights: ["400"] },
  { family: "Mina", weights: ["400", "700"] },
  { family: "Mingzat", weights: ["400"] },
  { family: "Miniver", weights: ["400"] },
  { family: "Miranda Sans", weights: ["400", "500", "600", "700", "400i", "500i", "600i", "700i"] },
  { family: "Miriam Libre", weights: ["400", "500", "600", "700"] },
  { family: "Mirza", weights: ["400", "500", "600", "700"] },
  { family: "Miss Fajardose", weights: ["400"] },
  { family: "Mitr", weights: ["200", "300", "400", "500", "600", "700"] },
  { family: "Mochiy Pop One", weights: ["400"] },
  { family: "Mochiy Pop P One", weights: ["400"] },
  { family: "Modak", weights: ["400"] },
  { family: "Modern Antiqua", weights: ["400"] },
  { family: "Moderustic", weights: ["300", "400", "500", "600", "700", "800"] },
  { family: "Mogra", weights: ["400"] },
  { family: "Mohave", weights: ["300", "400", "500", "600", "700", "300i", "400i", "500i", "600i", "700i"] },
  { family: "Moirai One", weights: ["400"] },
  { family: "Molengo", weights: ["400"] },
  { family: "Molle", weights: ["400i"] },
  { family: "Momo Signature", weights: ["400"] },
  { family: "Momo Trust Display", weights: ["400"] },
  { family: "Momo Trust Sans", weights: ["200", "300", "400", "500", "600", "700", "800"] },
  { family: "Mona Sans", weights: ["200", "300", "400", "500", "600", "700", "800", "900", "200i", "300i", "400i", "500i", "600i", "700i", "800i", "900i"] },
  { family: "Monda", weights: ["400", "500", "600", "700"] },
  { family: "Monofett", weights: ["400"] },
  { family: "Monomakh", weights: ["400"] },
  { family: "Monomaniac One", weights: ["400"] },
  { family: "Monoton", weights: ["400"] },
  { family: "Monsieur La Doulaise", weights: ["400"] },
  { family: "Montaga", weights: ["400"] },
  { family: "Montagu Slab", weights: ["100", "200", "300", "400", "500", "600", "700"] },
  { family: "MonteCarlo", weights: ["400"] },
  { family: "Montenegrin Gothic One", weights: ["400"] },
  { family: "Montez", weights: ["400"] },
  { family: "Montserrat", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900", "100i", "200i", "300i", "400i", "500i", "600i", "700i", "800i", "900i"] },
  { family: "Montserrat Alternates", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900", "100i", "200i", "300i", "400i", "500i", "600i", "700i", "800i", "900i"] },
  { family: "Montserrat Underline", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900", "100i", "200i", "300i", "400i", "500i", "600i", "700i", "800i", "900i"] },
  { family: "Moo Lah Lah", weights: ["400"] },
  { family: "Mooli", weights: ["400"] },
  { family: "Moon Dance", weights: ["400"] },
  { family: "Moul", weights: ["400"] },
  { family: "Moulpali", weights: ["400"] },
  { family: "Mountains of Christmas", weights: ["400", "700"] },
  { family: "Mouse Memoirs", weights: ["400"] },
  { family: "Mozilla Headline", weights: ["200", "300", "400", "500", "600", "700"] },
  { family: "Mozilla Text", weights: ["200", "300", "400", "500", "600", "700"] },
  { family: "Mr Bedfort", weights: ["400"] },
  { family: "Mr Dafoe", weights: ["400"] },
  { family: "Mr De Haviland", weights: ["400"] },
  { family: "Mrs Saint Delafield", weights: ["400"] },
  { family: "Mrs Sheppards", weights: ["400"] },
  { family: "Ms Madi", weights: ["400"] },
  { family: "Mukta", weights: ["200", "300", "400", "500", "600", "700", "800"] },
  { family: "Mukta Mahee", weights: ["200", "300", "400", "500", "600", "700", "800"] },
  { family: "Mukta Malar", weights: ["200", "300", "400", "500", "600", "700", "800"] },
  { family: "Mukta Vaani", weights: ["200", "300", "400", "500", "600", "700", "800"] },
  { family: "Mulish", weights: ["200", "300", "400", "500", "600", "700", "800", "900", "1000", "1000i", "200i", "300i", "400i", "500i", "600i", "700i", "800i", "900i"] },
  { family: "Murecho", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "MuseoModerno", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900", "100i", "200i", "300i", "400i", "500i", "600i", "700i", "800i", "900i"] },
  { family: "My Soul", weights: ["400"] },
  { family: "Mynerve", weights: ["400"] },
  { family: "Mystery Quest", weights: ["400"] },
  { family: "Nabla", weights: ["400"] },
  { family: "Namdhinggo", weights: ["400", "500", "600", "700", "800"] },
  { family: "Nanum Brush Script", weights: ["400"] },
  { family: "Nanum Gothic", weights: ["400", "700", "800"] },
  { family: "Nanum Gothic Coding", weights: ["400", "700"] },
  { family: "Nanum Myeongjo", weights: ["400", "700", "800"] },
  { family: "Nanum Pen Script", weights: ["400"] },
  { family: "Narnoor", weights: ["400", "500", "600", "700", "800"] },
  { family: "Nata Sans", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "National Park", weights: ["200", "300", "400", "500", "600", "700", "800"] },
  { family: "Neonderthaw", weights: ["400"] },
  { family: "Nerko One", weights: ["400"] },
  { family: "Neucha", weights: ["400"] },
  { family: "Neuton", weights: ["200", "300", "400", "700", "800", "400i"] },
  { family: "New Amsterdam", weights: ["400"] },
  { family: "New Rocker", weights: ["400"] },
  { family: "New Tegomin", weights: ["400"] },
  { family: "News Cycle", weights: ["400", "700"] },
  { family: "Newsreader", weights: ["200", "300", "400", "500", "600", "700", "800", "200i", "300i", "400i", "500i", "600i", "700i", "800i"] },
  { family: "Niconne", weights: ["400"] },
  { family: "Niramit", weights: ["200", "300", "400", "500", "600", "700", "200i", "300i", "400i", "500i", "600i", "700i"] },
  { family: "Nixie One", weights: ["400"] },
  { family: "Nobile", weights: ["400", "500", "700", "400i", "500i", "700i"] },
  { family: "Nokora", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Norican", weights: ["400"] },
  { family: "Nosifer", weights: ["400"] },
  { family: "Notable", weights: ["400"] },
  { family: "Nothing You Could Do", weights: ["400"] },
  { family: "Noticia Text", weights: ["400", "700", "400i", "700i"] },
  { family: "Noto Color Emoji", weights: ["400"] },
  { family: "Noto Emoji", weights: ["300", "400", "500", "600", "700"] },
  { family: "Noto Kufi Arabic", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Noto Music", weights: ["400"] },
  { family: "Noto Naskh Arabic", weights: ["400", "500", "600", "700"] },
  { family: "Noto Nastaliq Urdu", weights: ["400", "500", "600", "700"] },
  { family: "Noto Rashi Hebrew", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Noto Sans", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900", "100i", "200i", "300i", "400i", "500i", "600i", "700i", "800i", "900i"] },
  { family: "Noto Sans Adlam", weights: ["400", "500", "600", "700"] },
  { family: "Noto Sans Adlam Unjoined", weights: ["400", "500", "600", "700"] },
  { family: "Noto Sans Anatolian Hieroglyphs", weights: ["400"] },
  { family: "Noto Sans Arabic", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Noto Sans Armenian", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Noto Sans Avestan", weights: ["400"] },
  { family: "Noto Sans Balinese", weights: ["400", "500", "600", "700"] },
  { family: "Noto Sans Bamum", weights: ["400", "500", "600", "700"] },
  { family: "Noto Sans Bassa Vah", weights: ["400", "500", "600", "700"] },
  { family: "Noto Sans Batak", weights: ["400"] },
  { family: "Noto Sans Bengali", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Noto Sans Bhaiksuki", weights: ["400"] },
  { family: "Noto Sans Brahmi", weights: ["400"] },
  { family: "Noto Sans Buginese", weights: ["400"] },
  { family: "Noto Sans Buhid", weights: ["400"] },
  { family: "Noto Sans Canadian Aboriginal", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Noto Sans Carian", weights: ["400"] },
  { family: "Noto Sans Caucasian Albanian", weights: ["400"] },
  { family: "Noto Sans Chakma", weights: ["400"] },
  { family: "Noto Sans Cham", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Noto Sans Cherokee", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Noto Sans Chorasmian", weights: ["400"] },
  { family: "Noto Sans Coptic", weights: ["400"] },
  { family: "Noto Sans Cuneiform", weights: ["400"] },
  { family: "Noto Sans Cypriot", weights: ["400"] },
  { family: "Noto Sans Cypro Minoan", weights: ["400"] },
  { family: "Noto Sans Deseret", weights: ["400"] },
  { family: "Noto Sans Devanagari", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Noto Sans Display", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900", "100i", "200i", "300i", "400i", "500i", "600i", "700i", "800i", "900i"] },
  { family: "Noto Sans Duployan", weights: ["400", "700"] },
  { family: "Noto Sans Egyptian Hieroglyphs", weights: ["400"] },
  { family: "Noto Sans Elbasan", weights: ["400"] },
  { family: "Noto Sans Elymaic", weights: ["400"] },
  { family: "Noto Sans Ethiopic", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Noto Sans Georgian", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Noto Sans Glagolitic", weights: ["400"] },
  { family: "Noto Sans Gothic", weights: ["400"] },
  { family: "Noto Sans Grantha", weights: ["400"] },
  { family: "Noto Sans Gujarati", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Noto Sans Gunjala Gondi", weights: ["400", "500", "600", "700"] },
  { family: "Noto Sans Gurmukhi", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Noto Sans Hanifi Rohingya", weights: ["400", "500", "600", "700"] },
  { family: "Noto Sans Hanunoo", weights: ["400"] },
  { family: "Noto Sans Hatran", weights: ["400"] },
  { family: "Noto Sans Hebrew", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Noto Sans HK", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Noto Sans Imperial Aramaic", weights: ["400"] },
  { family: "Noto Sans Indic Siyaq Numbers", weights: ["400"] },
  { family: "Noto Sans Inscriptional Pahlavi", weights: ["400"] },
  { family: "Noto Sans Inscriptional Parthian", weights: ["400"] },
  { family: "Noto Sans Javanese", weights: ["400", "500", "600", "700"] },
  { family: "Noto Sans JP", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Noto Sans Kaithi", weights: ["400"] },
  { family: "Noto Sans Kannada", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Noto Sans Kawi", weights: ["400", "500", "600", "700"] },
  { family: "Noto Sans Kayah Li", weights: ["400", "500", "600", "700"] },
  { family: "Noto Sans Kharoshthi", weights: ["400"] },
  { family: "Noto Sans Khmer", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Noto Sans Khojki", weights: ["400"] },
  { family: "Noto Sans Khudawadi", weights: ["400"] },
  { family: "Noto Sans KR", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Noto Sans Lao", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Noto Sans Lao Looped", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Noto Sans Lepcha", weights: ["400"] },
  { family: "Noto Sans Limbu", weights: ["400"] },
  { family: "Noto Sans Linear A", weights: ["400"] },
  { family: "Noto Sans Linear B", weights: ["400"] },
  { family: "Noto Sans Lisu", weights: ["400", "500", "600", "700"] },
  { family: "Noto Sans Lycian", weights: ["400"] },
  { family: "Noto Sans Lydian", weights: ["400"] },
  { family: "Noto Sans Mahajani", weights: ["400"] },
  { family: "Noto Sans Malayalam", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Noto Sans Mandaic", weights: ["400"] },
  { family: "Noto Sans Manichaean", weights: ["400"] },
  { family: "Noto Sans Marchen", weights: ["400"] },
  { family: "Noto Sans Masaram Gondi", weights: ["400"] },
  { family: "Noto Sans Math", weights: ["400"] },
  { family: "Noto Sans Mayan Numerals", weights: ["400"] },
  { family: "Noto Sans Medefaidrin", weights: ["400", "500", "600", "700"] },
  { family: "Noto Sans Meetei Mayek", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Noto Sans Mende Kikakui", weights: ["400"] },
  { family: "Noto Sans Meroitic", weights: ["400"] },
  { family: "Noto Sans Miao", weights: ["400"] },
  { family: "Noto Sans Modi", weights: ["400"] },
  { family: "Noto Sans Mongolian", weights: ["400"] },
  { family: "Noto Sans Mono", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Noto Sans Mro", weights: ["400"] },
  { family: "Noto Sans Multani", weights: ["400"] },
  { family: "Noto Sans Myanmar", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Noto Sans Nabataean", weights: ["400"] },
  { family: "Noto Sans Nag Mundari", weights: ["400", "500", "600", "700"] },
  { family: "Noto Sans Nandinagari", weights: ["400"] },
  { family: "Noto Sans New Tai Lue", weights: ["400", "500", "600", "700"] },
  { family: "Noto Sans Newa", weights: ["400"] },
  { family: "Noto Sans NKo", weights: ["400"] },
  { family: "Noto Sans NKo Unjoined", weights: ["400", "500", "600", "700"] },
  { family: "Noto Sans Nushu", weights: ["400"] },
  { family: "Noto Sans Ogham", weights: ["400"] },
  { family: "Noto Sans Ol Chiki", weights: ["400", "500", "600", "700"] },
  { family: "Noto Sans Old Hungarian", weights: ["400"] },
  { family: "Noto Sans Old Italic", weights: ["400"] },
  { family: "Noto Sans Old North Arabian", weights: ["400"] },
  { family: "Noto Sans Old Permic", weights: ["400"] },
  { family: "Noto Sans Old Persian", weights: ["400"] },
  { family: "Noto Sans Old Sogdian", weights: ["400"] },
  { family: "Noto Sans Old South Arabian", weights: ["400"] },
  { family: "Noto Sans Old Turkic", weights: ["400"] },
  { family: "Noto Sans Oriya", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Noto Sans Osage", weights: ["400"] },
  { family: "Noto Sans Osmanya", weights: ["400"] },
  { family: "Noto Sans Pahawh Hmong", weights: ["400"] },
  { family: "Noto Sans Palmyrene", weights: ["400"] },
  { family: "Noto Sans Pau Cin Hau", weights: ["400"] },
  { family: "Noto Sans PhagsPa", weights: ["400"] },
  { family: "Noto Sans Phoenician", weights: ["400"] },
  { family: "Noto Sans Psalter Pahlavi", weights: ["400"] },
  { family: "Noto Sans Rejang", weights: ["400"] },
  { family: "Noto Sans Runic", weights: ["400"] },
  { family: "Noto Sans Samaritan", weights: ["400"] },
  { family: "Noto Sans Saurashtra", weights: ["400"] },
  { family: "Noto Sans SC", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Noto Sans Sharada", weights: ["400"] },
  { family: "Noto Sans Shavian", weights: ["400"] },
  { family: "Noto Sans Siddham", weights: ["400"] },
  { family: "Noto Sans SignWriting", weights: ["400"] },
  { family: "Noto Sans Sinhala", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Noto Sans Sogdian", weights: ["400"] },
  { family: "Noto Sans Sora Sompeng", weights: ["400", "500", "600", "700"] },
  { family: "Noto Sans Soyombo", weights: ["400"] },
  { family: "Noto Sans Sundanese", weights: ["400", "500", "600", "700"] },
  { family: "Noto Sans Sunuwar", weights: ["400"] },
  { family: "Noto Sans Syloti Nagri", weights: ["400"] },
  { family: "Noto Sans Symbols", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Noto Sans Symbols 2", weights: ["400"] },
  { family: "Noto Sans Syriac", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Noto Sans Syriac Eastern", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Noto Sans Syriac Western", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Noto Sans Tagalog", weights: ["400"] },
  { family: "Noto Sans Tagbanwa", weights: ["400"] },
  { family: "Noto Sans Tai Le", weights: ["400"] },
  { family: "Noto Sans Tai Tham", weights: ["400", "500", "600", "700"] },
  { family: "Noto Sans Tai Viet", weights: ["400"] },
  { family: "Noto Sans Takri", weights: ["400"] },
  { family: "Noto Sans Tamil", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Noto Sans Tamil Supplement", weights: ["400"] },
  { family: "Noto Sans Tangsa", weights: ["400", "500", "600", "700"] },
  { family: "Noto Sans TC", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Noto Sans Telugu", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Noto Sans Thaana", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Noto Sans Thai", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Noto Sans Thai Looped", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Noto Sans Tifinagh", weights: ["400"] },
  { family: "Noto Sans Tirhuta", weights: ["400"] },
  { family: "Noto Sans Ugaritic", weights: ["400"] },
  { family: "Noto Sans Vai", weights: ["400"] },
  { family: "Noto Sans Vithkuqi", weights: ["400", "500", "600", "700"] },
  { family: "Noto Sans Wancho", weights: ["400"] },
  { family: "Noto Sans Warang Citi", weights: ["400"] },
  { family: "Noto Sans Yi", weights: ["400"] },
  { family: "Noto Sans Zanabazar Square", weights: ["400"] },
  { family: "Noto Serif", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900", "100i", "200i", "300i", "400i", "500i", "600i", "700i", "800i", "900i"] },
  { family: "Noto Serif Ahom", weights: ["400"] },
  { family: "Noto Serif Armenian", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Noto Serif Balinese", weights: ["400"] },
  { family: "Noto Serif Bengali", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Noto Serif Devanagari", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Noto Serif Display", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900", "100i", "200i", "300i", "400i", "500i", "600i", "700i", "800i", "900i"] },
  { family: "Noto Serif Dives Akuru", weights: ["400"] },
  { family: "Noto Serif Dogra", weights: ["400"] },
  { family: "Noto Serif Ethiopic", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Noto Serif Georgian", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Noto Serif Grantha", weights: ["400"] },
  { family: "Noto Serif Gujarati", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Noto Serif Gurmukhi", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Noto Serif Hebrew", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Noto Serif Hentaigana", weights: ["200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Noto Serif HK", weights: ["200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Noto Serif JP", weights: ["200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Noto Serif Kannada", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Noto Serif Khitan Small Script", weights: ["400"] },
  { family: "Noto Serif Khmer", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Noto Serif Khojki", weights: ["400", "500", "600", "700"] },
  { family: "Noto Serif KR", weights: ["200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Noto Serif Lao", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Noto Serif Makasar", weights: ["400"] },
  { family: "Noto Serif Malayalam", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Noto Serif Myanmar", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Noto Serif NP Hmong", weights: ["400", "500", "600", "700"] },
  { family: "Noto Serif Old Uyghur", weights: ["400"] },
  { family: "Noto Serif Oriya", weights: ["400", "500", "600", "700"] },
  { family: "Noto Serif Ottoman Siyaq", weights: ["400"] },
  { family: "Noto Serif SC", weights: ["200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Noto Serif Sinhala", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Noto Serif Tamil", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900", "100i", "200i", "300i", "400i", "500i", "600i", "700i", "800i", "900i"] },
  { family: "Noto Serif Tangut", weights: ["400"] },
  { family: "Noto Serif TC", weights: ["200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Noto Serif Telugu", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Noto Serif Thai", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Noto Serif Tibetan", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Noto Serif Todhri", weights: ["400"] },
  { family: "Noto Serif Toto", weights: ["400", "500", "600", "700"] },
  { family: "Noto Serif Vithkuqi", weights: ["400", "500", "600", "700"] },
  { family: "Noto Serif Yezidi", weights: ["400", "500", "600", "700"] },
  { family: "Noto Traditional Nushu", weights: ["300", "400", "500", "600", "700"] },
  { family: "Noto Znamenny Musical Notation", weights: ["400"] },
  { family: "Nova Cut", weights: ["400"] },
  { family: "Nova Flat", weights: ["400"] },
  { family: "Nova Mono", weights: ["400"] },
  { family: "Nova Oval", weights: ["400"] },
  { family: "Nova Round", weights: ["400"] },
  { family: "Nova Script", weights: ["400"] },
  { family: "Nova Slim", weights: ["400"] },
  { family: "Nova Square", weights: ["400"] },
  { family: "NTR", weights: ["400"] },
  { family: "Numans", weights: ["400"] },
  { family: "Nunito", weights: ["200", "300", "400", "500", "600", "700", "800", "900", "1000", "1000i", "200i", "300i", "400i", "500i", "600i", "700i", "800i", "900i"] },
  { family: "Nunito Sans", weights: ["200", "300", "400", "500", "600", "700", "800", "900", "1000", "1000i", "200i", "300i", "400i", "500i", "600i", "700i", "800i", "900i"] },
  { family: "Nuosu SIL", weights: ["400"] },
  { family: "Odibee Sans", weights: ["400"] },
  { family: "Odor Mean Chey", weights: ["400"] },
  { family: "Offside", weights: ["400"] },
  { family: "Oi", weights: ["400"] },
  { family: "Ojuju", weights: ["200", "300", "400", "500", "600", "700", "800"] },
  { family: "Old Standard TT", weights: ["400", "700", "400i"] },
  { family: "Oldenburg", weights: ["400"] },
  { family: "Ole", weights: ["400"] },
  { family: "Oleo Script", weights: ["400", "700"] },
  { family: "Oleo Script Swash Caps", weights: ["400", "700"] },
  { family: "Onest", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Oooh Baby", weights: ["400"] },
  { family: "Open Sans", weights: ["300", "400", "500", "600", "700", "800", "300i", "400i", "500i", "600i", "700i", "800i"] },
  { family: "Oranienbaum", weights: ["400"] },
  { family: "Orbit", weights: ["400"] },
  { family: "Orbitron", weights: ["400", "500", "600", "700", "800", "900"] },
  { family: "Oregano", weights: ["400", "400i"] },
  { family: "Orelega One", weights: ["400"] },
  { family: "Orienta", weights: ["400"] },
  { family: "Original Surfer", weights: ["400"] },
  { family: "Oswald", weights: ["200", "300", "400", "500", "600", "700"] },
  { family: "Outfit", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Over the Rainbow", weights: ["400"] },
  { family: "Overlock", weights: ["400", "700", "900", "400i", "700i", "900i"] },
  { family: "Overlock SC", weights: ["400"] },
  { family: "Overpass", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900", "100i", "200i", "300i", "400i", "500i", "600i", "700i", "800i", "900i"] },
  { family: "Overpass Mono", weights: ["300", "400", "500", "600", "700"] },
  { family: "Ovo", weights: ["400"] },
  { family: "Oxanium", weights: ["200", "300", "400", "500", "600", "700", "800"] },
  { family: "Oxygen", weights: ["300", "400", "700"] },
  { family: "Oxygen Mono", weights: ["400"] },
  { family: "Pacifico", weights: ["400"] },
  { family: "Padauk", weights: ["400", "700"] },
  { family: "Padyakke Expanded One", weights: ["400"] },
  { family: "Palanquin", weights: ["100", "200", "300", "400", "500", "600", "700"] },
  { family: "Palanquin Dark", weights: ["400", "500", "600", "700"] },
  { family: "Palette Mosaic", weights: ["400"] },
  { family: "Pangolin", weights: ["400"] },
  { family: "Paprika", weights: ["400"] },
  { family: "Parastoo", weights: ["400", "500", "600", "700"] },
  { family: "Parisienne", weights: ["400"] },
  { family: "Parkinsans", weights: ["300", "400", "500", "600", "700", "800"] },
  { family: "Passero One", weights: ["400"] },
  { family: "Passion One", weights: ["400", "700", "900"] },
  { family: "Passions Conflict", weights: ["400"] },
  { family: "Pathway Extreme", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900", "100i", "200i", "300i", "400i", "500i", "600i", "700i", "800i", "900i"] },
  { family: "Pathway Gothic One", weights: ["400"] },
  { family: "Patrick Hand", weights: ["400"] },
  { family: "Patrick Hand SC", weights: ["400"] },
  { family: "Pattaya", weights: ["400"] },
  { family: "Patua One", weights: ["400"] },
  { family: "Pavanam", weights: ["400"] },
  { family: "Paytone One", weights: ["400"] },
  { family: "Peddana", weights: ["400"] },
  { family: "Peralta", weights: ["400"] },
  { family: "Permanent Marker", weights: ["400"] },
  { family: "Petemoss", weights: ["400"] },
  { family: "Petit Formal Script", weights: ["400"] },
  { family: "Petrona", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900", "100i", "200i", "300i", "400i", "500i", "600i", "700i", "800i", "900i"] },
  { family: "Phetsarath", weights: ["400", "700"] },
  { family: "Philosopher", weights: ["400", "700", "400i", "700i"] },
  { family: "Phudu", weights: ["300", "400", "500", "600", "700", "800", "900"] },
  { family: "Piazzolla", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900", "100i", "200i", "300i", "400i", "500i", "600i", "700i", "800i", "900i"] },
  { family: "Piedra", weights: ["400"] },
  { family: "Pinyon Script", weights: ["400"] },
  { family: "Pirata One", weights: ["400"] },
  { family: "Pixelify Sans", weights: ["400", "500", "600", "700"] },
  { family: "Plaster", weights: ["400"] },
  { family: "Platypi", weights: ["300", "400", "500", "600", "700", "800", "300i", "400i", "500i", "600i", "700i", "800i"] },
  { family: "Play", weights: ["400", "700"] },
  { family: "Playball", weights: ["400"] },
  { family: "Playfair", weights: ["300", "400", "500", "600", "700", "800", "900", "300i", "400i", "500i", "600i", "700i", "800i", "900i"] },
  { family: "Playfair Display", weights: ["400", "500", "600", "700", "800", "900", "400i", "500i", "600i", "700i", "800i", "900i"] },
  { family: "Playfair Display SC", weights: ["400", "700", "900", "400i", "700i", "900i"] },
  { family: "Playpen Sans", weights: ["100", "200", "300", "400", "500", "600", "700", "800"] },
  { family: "Playpen Sans Arabic", weights: ["100", "200", "300", "400", "500", "600", "700", "800"] },
  { family: "Playpen Sans Deva", weights: ["100", "200", "300", "400", "500", "600", "700", "800"] },
  { family: "Playpen Sans Hebrew", weights: ["100", "200", "300", "400", "500", "600", "700", "800"] },
  { family: "Playpen Sans Thai", weights: ["100", "200", "300", "400", "500", "600", "700", "800"] },
  { family: "Playwrite AR", weights: ["100", "200", "300", "400"] },
  { family: "Playwrite AR Guides", weights: ["400"] },
  { family: "Playwrite AT", weights: ["100", "200", "300", "400", "100i", "200i", "300i", "400i"] },
  { family: "Playwrite AT Guides", weights: ["400", "400i"] },
  { family: "Playwrite AU NSW", weights: ["100", "200", "300", "400"] },
  { family: "Playwrite AU NSW Guides", weights: ["400"] },
  { family: "Playwrite AU QLD", weights: ["100", "200", "300", "400"] },
  { family: "Playwrite AU QLD Guides", weights: ["400"] },
  { family: "Playwrite AU SA", weights: ["100", "200", "300", "400"] },
  { family: "Playwrite AU SA Guides", weights: ["400"] },
  { family: "Playwrite AU TAS", weights: ["100", "200", "300", "400"] },
  { family: "Playwrite AU TAS Guides", weights: ["400"] },
  { family: "Playwrite AU VIC", weights: ["100", "200", "300", "400"] },
  { family: "Playwrite AU VIC Guides", weights: ["400"] },
  { family: "Playwrite BE VLG", weights: ["100", "200", "300", "400"] },
  { family: "Playwrite BE VLG Guides", weights: ["400"] },
  { family: "Playwrite BE WAL", weights: ["100", "200", "300", "400"] },
  { family: "Playwrite BE WAL Guides", weights: ["400"] },
  { family: "Playwrite BR", weights: ["100", "200", "300", "400"] },
  { family: "Playwrite BR Guides", weights: ["400"] },
  { family: "Playwrite CA", weights: ["100", "200", "300", "400"] },
  { family: "Playwrite CA Guides", weights: ["400"] },
  { family: "Playwrite CL", weights: ["100", "200", "300", "400"] },
  { family: "Playwrite CL Guides", weights: ["400"] },
  { family: "Playwrite CO", weights: ["100", "200", "300", "400"] },
  { family: "Playwrite CO Guides", weights: ["400"] },
  { family: "Playwrite CU", weights: ["100", "200", "300", "400"] },
  { family: "Playwrite CU Guides", weights: ["400"] },
  { family: "Playwrite CZ", weights: ["100", "200", "300", "400"] },
  { family: "Playwrite CZ Guides", weights: ["400"] },
  { family: "Playwrite DE Grund", weights: ["100", "200", "300", "400"] },
  { family: "Playwrite DE Grund Guides", weights: ["400"] },
  { family: "Playwrite DE LA", weights: ["100", "200", "300", "400"] },
  { family: "Playwrite DE LA Guides", weights: ["400"] },
  { family: "Playwrite DE SAS", weights: ["100", "200", "300", "400"] },
  { family: "Playwrite DE SAS Guides", weights: ["400"] },
  { family: "Playwrite DE VA", weights: ["100", "200", "300", "400"] },
  { family: "Playwrite DE VA Guides", weights: ["400"] },
  { family: "Playwrite DK Loopet", weights: ["100", "200", "300", "400"] },
  { family: "Playwrite DK Loopet Guides", weights: ["400"] },
  { family: "Playwrite DK Uloopet", weights: ["100", "200", "300", "400"] },
  { family: "Playwrite DK Uloopet Guides", weights: ["400"] },
  { family: "Playwrite ES", weights: ["100", "200", "300", "400"] },
  { family: "Playwrite ES Deco", weights: ["100", "200", "300", "400"] },
  { family: "Playwrite ES Deco Guides", weights: ["400"] },
  { family: "Playwrite ES Guides", weights: ["400"] },
  { family: "Playwrite FR Moderne", weights: ["100", "200", "300", "400"] },
  { family: "Playwrite FR Moderne Guides", weights: ["400"] },
  { family: "Playwrite FR Trad", weights: ["100", "200", "300", "400"] },
  { family: "Playwrite FR Trad Guides", weights: ["400"] },
  { family: "Playwrite GB J", weights: ["100", "200", "300", "400", "100i", "200i", "300i", "400i"] },
  { family: "Playwrite GB J Guides", weights: ["400", "400i"] },
  { family: "Playwrite GB S", weights: ["100", "200", "300", "400", "100i", "200i", "300i", "400i"] },
  { family: "Playwrite GB S Guides", weights: ["400", "400i"] },
  { family: "Playwrite HR", weights: ["100", "200", "300", "400"] },
  { family: "Playwrite HR Guides", weights: ["400"] },
  { family: "Playwrite HR Lijeva", weights: ["100", "200", "300", "400"] },
  { family: "Playwrite HR Lijeva Guides", weights: ["400"] },
  { family: "Playwrite HU", weights: ["100", "200", "300", "400"] },
  { family: "Playwrite HU Guides", weights: ["400"] },
  { family: "Playwrite ID", weights: ["100", "200", "300", "400"] },
  { family: "Playwrite ID Guides", weights: ["400"] },
  { family: "Playwrite IE", weights: ["100", "200", "300", "400"] },
  { family: "Playwrite IE Guides", weights: ["400"] },
  { family: "Playwrite IN", weights: ["100", "200", "300", "400"] },
  { family: "Playwrite IN Guides", weights: ["400"] },
  { family: "Playwrite IS", weights: ["100", "200", "300", "400"] },
  { family: "Playwrite IS Guides", weights: ["400"] },
  { family: "Playwrite IT Moderna", weights: ["100", "200", "300", "400"] },
  { family: "Playwrite IT Moderna Guides", weights: ["400"] },
  { family: "Playwrite IT Trad", weights: ["100", "200", "300", "400"] },
  { family: "Playwrite IT Trad Guides", weights: ["400"] },
  { family: "Playwrite MX", weights: ["100", "200", "300", "400"] },
  { family: "Playwrite MX Guides", weights: ["400"] },
  { family: "Playwrite NG Modern", weights: ["100", "200", "300", "400"] },
  { family: "Playwrite NG Modern Guides", weights: ["400"] },
  { family: "Playwrite NL", weights: ["100", "200", "300", "400"] },
  { family: "Playwrite NL Guides", weights: ["400"] },
  { family: "Playwrite NO", weights: ["100", "200", "300", "400"] },
  { family: "Playwrite NO Guides", weights: ["400"] },
  { family: "Playwrite NZ", weights: ["100", "200", "300", "400"] },
  { family: "Playwrite NZ Basic", weights: ["100", "200", "300", "400"] },
  { family: "Playwrite NZ Basic Guides", weights: ["400"] },
  { family: "Playwrite NZ Guides", weights: ["400"] },
  { family: "Playwrite PE", weights: ["100", "200", "300", "400"] },
  { family: "Playwrite PE Guides", weights: ["400"] },
  { family: "Playwrite PL", weights: ["100", "200", "300", "400"] },
  { family: "Playwrite PL Guides", weights: ["400"] },
  { family: "Playwrite PT", weights: ["100", "200", "300", "400"] },
  { family: "Playwrite PT Guides", weights: ["400"] },
  { family: "Playwrite RO", weights: ["100", "200", "300", "400"] },
  { family: "Playwrite RO Guides", weights: ["400"] },
  { family: "Playwrite SK", weights: ["100", "200", "300", "400"] },
  { family: "Playwrite SK Guides", weights: ["400"] },
  { family: "Playwrite TZ", weights: ["100", "200", "300", "400"] },
  { family: "Playwrite TZ Guides", weights: ["400"] },
  { family: "Playwrite US Modern", weights: ["100", "200", "300", "400"] },
  { family: "Playwrite US Modern Guides", weights: ["400"] },
  { family: "Playwrite US Trad", weights: ["100", "200", "300", "400"] },
  { family: "Playwrite US Trad Guides", weights: ["400"] },
  { family: "Playwrite VN", weights: ["100", "200", "300", "400"] },
  { family: "Playwrite VN Guides", weights: ["400"] },
  { family: "Playwrite ZA", weights: ["100", "200", "300", "400"] },
  { family: "Playwrite ZA Guides", weights: ["400"] },
  { family: "Pliant", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900", "100i", "200i", "300i", "400i", "500i", "600i", "700i", "800i", "900i"] },
  { family: "Plus Jakarta Sans", weights: ["200", "300", "400", "500", "600", "700", "800", "200i", "300i", "400i", "500i", "600i", "700i", "800i"] },
  { family: "Pochaevsk", weights: ["400"] },
  { family: "Podkova", weights: ["400", "500", "600", "700", "800"] },
  { family: "Poetsen One", weights: ["400"] },
  { family: "Poiret One", weights: ["400"] },
  { family: "Poller One", weights: ["400"] },
  { family: "Poltawski Nowy", weights: ["400", "500", "600", "700", "400i", "500i", "600i", "700i"] },
  { family: "Poly", weights: ["400", "400i"] },
  { family: "Pompiere", weights: ["400"] },
  { family: "Ponnala", weights: ["400"] },
  { family: "Ponomar", weights: ["400"] },
  { family: "Pontano Sans", weights: ["300", "400", "500", "600", "700"] },
  { family: "Poor Story", weights: ["400"] },
  { family: "Poppins", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900", "100i", "200i", "300i", "400i", "500i", "600i", "700i", "800i", "900i"] },
  { family: "Port Lligat Sans", weights: ["400"] },
  { family: "Port Lligat Slab", weights: ["400"] },
  { family: "Potta One", weights: ["400"] },
  { family: "Pragati Narrow", weights: ["400", "700"] },
  { family: "Praise", weights: ["400"] },
  { family: "Prata", weights: ["400"] },
  { family: "Preahvihear", weights: ["400"] },
  { family: "Press Start 2P", weights: ["400"] },
  { family: "Pridi", weights: ["200", "300", "400", "500", "600", "700"] },
  { family: "Princess Sofia", weights: ["400"] },
  { family: "Prociono", weights: ["400"] },
  { family: "Prompt", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900", "100i", "200i", "300i", "400i", "500i", "600i", "700i", "800i", "900i"] },
  { family: "Prosto One", weights: ["400"] },
  { family: "Protest Guerrilla", weights: ["400"] },
  { family: "Protest Revolution", weights: ["400"] },
  { family: "Protest Riot", weights: ["400"] },
  { family: "Protest Strike", weights: ["400"] },
  { family: "Proza Libre", weights: ["400", "500", "600", "700", "800", "400i", "500i", "600i", "700i", "800i"] },
  { family: "PT Mono", weights: ["400"] },
  { family: "PT Sans", weights: ["400", "700", "400i", "700i"] },
  { family: "PT Sans Caption", weights: ["400", "700"] },
  { family: "PT Sans Narrow", weights: ["400", "700"] },
  { family: "PT Serif", weights: ["400", "700", "400i", "700i"] },
  { family: "PT Serif Caption", weights: ["400", "400i"] },
  { family: "Public Sans", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900", "100i", "200i", "300i", "400i", "500i", "600i", "700i", "800i", "900i"] },
  { family: "Puppies Play", weights: ["400"] },
  { family: "Puritan", weights: ["400", "700", "400i", "700i"] },
  { family: "Purple Purse", weights: ["400"] },
  { family: "Qahiri", weights: ["400"] },
  { family: "Quando", weights: ["400"] },
  { family: "Quantico", weights: ["400", "700", "400i", "700i"] },
  { family: "Quattrocento", weights: ["400", "700"] },
  { family: "Quattrocento Sans", weights: ["400", "700", "400i", "700i"] },
  { family: "Questrial", weights: ["400"] },
  { family: "Quicksand", weights: ["300", "400", "500", "600", "700"] },
  { family: "Quintessential", weights: ["400"] },
  { family: "Qwigley", weights: ["400"] },
  { family: "Qwitcher Grypen", weights: ["400", "700"] },
  { family: "Racing Sans One", weights: ["400"] },
  { family: "Radio Canada", weights: ["300", "400", "500", "600", "700", "300i", "400i", "500i", "600i", "700i"] },
  { family: "Radio Canada Big", weights: ["400", "500", "600", "700", "400i", "500i", "600i", "700i"] },
  { family: "Radley", weights: ["400", "400i"] },
  { family: "Rajdhani", weights: ["300", "400", "500", "600", "700"] },
  { family: "Rakkas", weights: ["400"] },
  { family: "Raleway", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900", "100i", "200i", "300i", "400i", "500i", "600i", "700i", "800i", "900i"] },
  { family: "Raleway Dots", weights: ["400"] },
  { family: "Ramabhadra", weights: ["400"] },
  { family: "Ramaraja", weights: ["400"] },
  { family: "Rambla", weights: ["400", "700", "400i", "700i"] },
  { family: "Rammetto One", weights: ["400"] },
  { family: "Rampart One", weights: ["400"] },
  { family: "Ramsina", weights: ["400"] },
  { family: "Ranchers", weights: ["400"] },
  { family: "Rancho", weights: ["400"] },
  { family: "Ranga", weights: ["400", "700"] },
  { family: "Rasa", weights: ["300", "400", "500", "600", "700", "300i", "400i", "500i", "600i", "700i"] },
  { family: "Rationale", weights: ["400"] },
  { family: "Ravi Prakash", weights: ["400"] },
  { family: "Readex Pro", weights: ["200", "300", "400", "500", "600", "700"] },
  { family: "Recursive", weights: ["300", "400", "500", "600", "700", "800", "900", "1000"] },
  { family: "Red Hat Display", weights: ["300", "400", "500", "600", "700", "800", "900", "300i", "400i", "500i", "600i", "700i", "800i", "900i"] },
  { family: "Red Hat Mono", weights: ["300", "400", "500", "600", "700", "300i", "400i", "500i", "600i", "700i"] },
  { family: "Red Hat Text", weights: ["300", "400", "500", "600", "700", "300i", "400i", "500i", "600i", "700i"] },
  { family: "Red Rose", weights: ["300", "400", "500", "600", "700"] },
  { family: "Redacted", weights: ["400"] },
  { family: "Redacted Script", weights: ["300", "400", "700"] },
  { family: "Reddit Mono", weights: ["200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Reddit Sans", weights: ["200", "300", "400", "500", "600", "700", "800", "900", "200i", "300i", "400i", "500i", "600i", "700i", "800i", "900i"] },
  { family: "Reddit Sans Condensed", weights: ["200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Redressed", weights: ["400"] },
  { family: "Reem Kufi", weights: ["400", "500", "600", "700"] },
  { family: "Reem Kufi Fun", weights: ["400", "500", "600", "700"] },
  { family: "Reem Kufi Ink", weights: ["400"] },
  { family: "Reenie Beanie", weights: ["400"] },
  { family: "Reggae One", weights: ["400"] },
  { family: "REM", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900", "100i", "200i", "300i", "400i", "500i", "600i", "700i", "800i", "900i"] },
  { family: "Rethink Sans", weights: ["400", "500", "600", "700", "800", "400i", "500i", "600i", "700i", "800i"] },
  { family: "Revalia", weights: ["400"] },
  { family: "Rhodium Libre", weights: ["400"] },
  { family: "Ribeye", weights: ["400"] },
  { family: "Ribeye Marrow", weights: ["400"] },
  { family: "Righteous", weights: ["400"] },
  { family: "Risque", weights: ["400"] },
  { family: "Road Rage", weights: ["400"] },
  { family: "Roboto", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900", "100i", "200i", "300i", "400i", "500i", "600i", "700i", "800i", "900i"] },
  { family: "Roboto Condensed", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900", "100i", "200i", "300i", "400i", "500i", "600i", "700i", "800i", "900i"] },
  { family: "Roboto Flex", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900", "1000"] },
  { family: "Roboto Mono", weights: ["100", "200", "300", "400", "500", "600", "700", "100i", "200i", "300i", "400i", "500i", "600i", "700i"] },
  { family: "Roboto Serif", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900", "100i", "200i", "300i", "400i", "500i", "600i", "700i", "800i", "900i"] },
  { family: "Roboto Slab", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Rochester", weights: ["400"] },
  { family: "Rock 3D", weights: ["400"] },
  { family: "Rock Salt", weights: ["400"] },
  { family: "RocknRoll One", weights: ["400"] },
  { family: "Rokkitt", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900", "100i", "200i", "300i", "400i", "500i", "600i", "700i", "800i", "900i"] },
  { family: "Romanesco", weights: ["400"] },
  { family: "Ropa Sans", weights: ["400", "400i"] },
  { family: "Rosario", weights: ["300", "400", "500", "600", "700", "300i", "400i", "500i", "600i", "700i"] },
  { family: "Rosarivo", weights: ["400", "400i"] },
  { family: "Rouge Script", weights: ["400"] },
  { family: "Rowdies", weights: ["300", "400", "700"] },
  { family: "Rozha One", weights: ["400"] },
  { family: "Rubik", weights: ["300", "400", "500", "600", "700", "800", "900", "300i", "400i", "500i", "600i", "700i", "800i", "900i"] },
  { family: "Rubik 80s Fade", weights: ["400"] },
  { family: "Rubik Beastly", weights: ["400"] },
  { family: "Rubik Broken Fax", weights: ["400"] },
  { family: "Rubik Bubbles", weights: ["400"] },
  { family: "Rubik Burned", weights: ["400"] },
  { family: "Rubik Dirt", weights: ["400"] },
  { family: "Rubik Distressed", weights: ["400"] },
  { family: "Rubik Doodle Shadow", weights: ["400"] },
  { family: "Rubik Doodle Triangles", weights: ["400"] },
  { family: "Rubik Gemstones", weights: ["400"] },
  { family: "Rubik Glitch", weights: ["400"] },
  { family: "Rubik Glitch Pop", weights: ["400"] },
  { family: "Rubik Iso", weights: ["400"] },
  { family: "Rubik Lines", weights: ["400"] },
  { family: "Rubik Maps", weights: ["400"] },
  { family: "Rubik Marker Hatch", weights: ["400"] },
  { family: "Rubik Maze", weights: ["400"] },
  { family: "Rubik Microbe", weights: ["400"] },
  { family: "Rubik Mono One", weights: ["400"] },
  { family: "Rubik Moonrocks", weights: ["400"] },
  { family: "Rubik Pixels", weights: ["400"] },
  { family: "Rubik Puddles", weights: ["400"] },
  { family: "Rubik Scribble", weights: ["400"] },
  { family: "Rubik Spray Paint", weights: ["400"] },
  { family: "Rubik Storm", weights: ["400"] },
  { family: "Rubik Vinyl", weights: ["400"] },
  { family: "Rubik Wet Paint", weights: ["400"] },
  { family: "Ruda", weights: ["400", "500", "600", "700", "800", "900"] },
  { family: "Rufina", weights: ["400", "700"] },
  { family: "Ruge Boogie", weights: ["400"] },
  { family: "Ruluko", weights: ["400"] },
  { family: "Rum Raisin", weights: ["400"] },
  { family: "Ruslan Display", weights: ["400"] },
  { family: "Russo One", weights: ["400"] },
  { family: "Ruthie", weights: ["400"] },
  { family: "Ruwudu", weights: ["400", "500", "600", "700"] },
  { family: "Rye", weights: ["400"] },
  { family: "Sacramento", weights: ["400"] },
  { family: "Sahitya", weights: ["400", "700"] },
  { family: "Sail", weights: ["400"] },
  { family: "Saira", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900", "100i", "200i", "300i", "400i", "500i", "600i", "700i", "800i", "900i"] },
  { family: "Saira Condensed", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Saira Extra Condensed", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Saira Semi Condensed", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Saira Stencil", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900", "100i", "200i", "300i", "400i", "500i", "600i", "700i", "800i", "900i"] },
  { family: "Salsa", weights: ["400"] },
  { family: "Sanchez", weights: ["400", "400i"] },
  { family: "Sancreek", weights: ["400"] },
  { family: "Sankofa Display", weights: ["400"] },
  { family: "Sansation", weights: ["300", "400", "700", "300i", "400i", "700i"] },
  { family: "Sansita", weights: ["400", "700", "800", "900", "400i", "700i", "800i", "900i"] },
  { family: "Sansita Swashed", weights: ["300", "400", "500", "600", "700", "800", "900"] },
  { family: "Sarabun", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "100i", "200i", "300i", "400i", "500i", "600i", "700i", "800i"] },
  { family: "Sarala", weights: ["400", "700"] },
  { family: "Sarina", weights: ["400"] },
  { family: "Sarpanch", weights: ["400", "500", "600", "700", "800", "900"] },
  { family: "Sassy Frass", weights: ["400"] },
  { family: "Satisfy", weights: ["400"] },
  { family: "Savate", weights: ["200", "300", "400", "500", "600", "700", "800", "900", "200i", "300i", "400i", "500i", "600i", "700i", "800i", "900i"] },
  { family: "Sawarabi Gothic", weights: ["400"] },
  { family: "Sawarabi Mincho", weights: ["400"] },
  { family: "Scada", weights: ["400", "700", "400i", "700i"] },
  { family: "Scheherazade New", weights: ["400", "500", "600", "700"] },
  { family: "Schibsted Grotesk", weights: ["400", "500", "600", "700", "800", "900", "400i", "500i", "600i", "700i", "800i", "900i"] },
  { family: "Schoolbell", weights: ["400"] },
  { family: "Science Gothic", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Scope One", weights: ["400"] },
  { family: "Seaweed Script", weights: ["400"] },
  { family: "Secular One", weights: ["400"] },
  { family: "Sedan", weights: ["400", "400i"] },
  { family: "Sedan SC", weights: ["400"] },
  { family: "Sedgwick Ave", weights: ["400"] },
  { family: "Sedgwick Ave Display", weights: ["400"] },
  { family: "Sekuya", weights: ["400"] },
  { family: "Sen", weights: ["400", "500", "600", "700", "800"] },
  { family: "Send Flowers", weights: ["400"] },
  { family: "Sevillana", weights: ["400"] },
  { family: "Seymour One", weights: ["400"] },
  { family: "Shadows Into Light", weights: ["400"] },
  { family: "Shadows Into Light Two", weights: ["400"] },
  { family: "Shafarik", weights: ["400"] },
  { family: "Shalimar", weights: ["400"] },
  { family: "Shantell Sans", weights: ["300", "400", "500", "600", "700", "800", "300i", "400i", "500i", "600i", "700i", "800i"] },
  { family: "Shanti", weights: ["400"] },
  { family: "Share", weights: ["400", "700", "400i", "700i"] },
  { family: "Share Tech", weights: ["400"] },
  { family: "Share Tech Mono", weights: ["400"] },
  { family: "Shippori Antique", weights: ["400"] },
  { family: "Shippori Antique B1", weights: ["400"] },
  { family: "Shippori Mincho", weights: ["400", "500", "600", "700", "800"] },
  { family: "Shippori Mincho B1", weights: ["400", "500", "600", "700", "800"] },
  { family: "Shizuru", weights: ["400"] },
  { family: "Shojumaru", weights: ["400"] },
  { family: "Short Stack", weights: ["400"] },
  { family: "Shrikhand", weights: ["400"] },
  { family: "Siemreap", weights: ["400"] },
  { family: "Sigmar", weights: ["400"] },
  { family: "Sigmar One", weights: ["400"] },
  { family: "Signika", weights: ["300", "400", "500", "600", "700"] },
  { family: "Signika Negative", weights: ["300", "400", "500", "600", "700"] },
  { family: "Silkscreen", weights: ["400", "700"] },
  { family: "Simonetta", weights: ["400", "900", "400i", "900i"] },
  { family: "Single Day", weights: ["400"] },
  { family: "Sintony", weights: ["400", "700"] },
  { family: "Sirin Stencil", weights: ["400"] },
  { family: "Sirivennela", weights: ["400"] },
  { family: "Six Caps", weights: ["400"] },
  { family: "Sixtyfour", weights: ["400"] },
  { family: "Sixtyfour Convergence", weights: ["400"] },
  { family: "Skranji", weights: ["400", "700"] },
  { family: "Slabo 13px", weights: ["400"] },
  { family: "Slabo 27px", weights: ["400"] },
  { family: "Slackey", weights: ["400"] },
  { family: "Slackside One", weights: ["400"] },
  { family: "Smokum", weights: ["400"] },
  { family: "Smooch", weights: ["400"] },
  { family: "Smooch Sans", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Smythe", weights: ["400"] },
  { family: "SN Pro", weights: ["200", "300", "400", "500", "600", "700", "800", "900", "200i", "300i", "400i", "500i", "600i", "700i", "800i", "900i"] },
  { family: "Sniglet", weights: ["400", "800"] },
  { family: "Snippet", weights: ["400"] },
  { family: "Snowburst One", weights: ["400"] },
  { family: "Sofadi One", weights: ["400"] },
  { family: "Sofia", weights: ["400"] },
  { family: "Sofia Sans", weights: ["1", "100", "200", "300", "400", "500", "600", "700", "800", "900", "1000", "1000i", "100i", "1i", "200i", "300i", "400i", "500i", "600i", "700i", "800i", "900i"] },
  { family: "Sofia Sans Condensed", weights: ["1", "100", "200", "300", "400", "500", "600", "700", "800", "900", "1000", "1000i", "100i", "1i", "200i", "300i", "400i", "500i", "600i", "700i", "800i", "900i"] },
  { family: "Sofia Sans Extra Condensed", weights: ["1", "100", "200", "300", "400", "500", "600", "700", "800", "900", "1000", "1000i", "100i", "1i", "200i", "300i", "400i", "500i", "600i", "700i", "800i", "900i"] },
  { family: "Sofia Sans Semi Condensed", weights: ["1", "100", "200", "300", "400", "500", "600", "700", "800", "900", "1000", "1000i", "100i", "1i", "200i", "300i", "400i", "500i", "600i", "700i", "800i", "900i"] },
  { family: "Solitreo", weights: ["400"] },
  { family: "Solway", weights: ["300", "400", "500", "700", "800"] },
  { family: "Sometype Mono", weights: ["400", "500", "600", "700", "400i", "500i", "600i", "700i"] },
  { family: "Song Myung", weights: ["400"] },
  { family: "Sono", weights: ["200", "300", "400", "500", "600", "700", "800"] },
  { family: "Sonsie One", weights: ["400"] },
  { family: "Sora", weights: ["100", "200", "300", "400", "500", "600", "700", "800"] },
  { family: "Sorts Mill Goudy", weights: ["400", "400i"] },
  { family: "Sour Gummy", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900", "100i", "200i", "300i", "400i", "500i", "600i", "700i", "800i", "900i"] },
  { family: "Source Code Pro", weights: ["200", "300", "400", "500", "600", "700", "800", "900", "200i", "300i", "400i", "500i", "600i", "700i", "800i", "900i"] },
  { family: "Source Sans 3", weights: ["200", "300", "400", "500", "600", "700", "800", "900", "200i", "300i", "400i", "500i", "600i", "700i", "800i", "900i"] },
  { family: "Source Serif 4", weights: ["200", "300", "400", "500", "600", "700", "800", "900", "200i", "300i", "400i", "500i", "600i", "700i", "800i", "900i"] },
  { family: "Space Grotesk", weights: ["300", "400", "500", "600", "700"] },
  { family: "Space Mono", weights: ["400", "700", "400i", "700i"] },
  { family: "Special Elite", weights: ["400"] },
  { family: "Special Gothic", weights: ["400", "500", "600", "700"] },
  { family: "Special Gothic Condensed One", weights: ["400"] },
  { family: "Special Gothic Expanded One", weights: ["400"] },
  { family: "Spectral", weights: ["200", "300", "400", "500", "600", "700", "800", "200i", "300i", "400i", "500i", "600i", "700i", "800i"] },
  { family: "Spectral SC", weights: ["200", "300", "400", "500", "600", "700", "800", "200i", "300i", "400i", "500i", "600i", "700i", "800i"] },
  { family: "Spicy Rice", weights: ["400"] },
  { family: "Spinnaker", weights: ["400"] },
  { family: "Spirax", weights: ["400"] },
  { family: "Splash", weights: ["400"] },
  { family: "Spline Sans", weights: ["300", "400", "500", "600", "700"] },
  { family: "Spline Sans Mono", weights: ["300", "400", "500", "600", "700", "300i", "400i", "500i", "600i", "700i"] },
  { family: "Squada One", weights: ["400"] },
  { family: "Square Peg", weights: ["400"] },
  { family: "Sree Krushnadevaraya", weights: ["400"] },
  { family: "Sriracha", weights: ["400"] },
  { family: "Srisakdi", weights: ["400", "700"] },
  { family: "Staatliches", weights: ["400"] },
  { family: "Stack Sans Headline", weights: ["200", "300", "400", "500", "600", "700"] },
  { family: "Stack Sans Notch", weights: ["200", "300", "400", "500", "600", "700"] },
  { family: "Stack Sans Text", weights: ["200", "300", "400", "500", "600", "700"] },
  { family: "Stalemate", weights: ["400"] },
  { family: "Stalinist One", weights: ["400"] },
  { family: "Stardos Stencil", weights: ["400", "700"] },
  { family: "Stick", weights: ["400"] },
  { family: "Stick No Bills", weights: ["200", "300", "400", "500", "600", "700", "800"] },
  { family: "Stint Ultra Condensed", weights: ["400"] },
  { family: "Stint Ultra Expanded", weights: ["400"] },
  { family: "STIX Two Math", weights: ["400"] },
  { family: "STIX Two Text", weights: ["400", "500", "600", "700", "400i", "500i", "600i", "700i"] },
  { family: "Stoke", weights: ["300", "400"] },
  { family: "Story Script", weights: ["400"] },
  { family: "Strait", weights: ["400"] },
  { family: "Strichpunkt Sans", weights: ["400", "500", "600", "700", "800", "900"] },
  { family: "Style Script", weights: ["400"] },
  { family: "Stylish", weights: ["400"] },
  { family: "Sue Ellen Francisco", weights: ["400"] },
  { family: "Suez One", weights: ["400"] },
  { family: "Sulphur Point", weights: ["300", "400", "700"] },
  { family: "Sumana", weights: ["400", "700"] },
  { family: "Sunflower", weights: ["300", "500", "700"] },
  { family: "Sunshiney", weights: ["400"] },
  { family: "Supermercado One", weights: ["400"] },
  { family: "Sura", weights: ["400", "700"] },
  { family: "Suranna", weights: ["400"] },
  { family: "Suravaram", weights: ["400"] },
  { family: "SUSE", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900", "100i", "200i", "300i", "400i", "500i", "600i", "700i", "800i", "900i"] },
  { family: "SUSE Mono", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "100i", "200i", "300i", "400i", "500i", "600i", "700i", "800i"] },
  { family: "Suwannaphum", weights: ["100", "300", "400", "700", "900"] },
  { family: "Swanky and Moo Moo", weights: ["400"] },
  { family: "Syncopate", weights: ["400", "700"] },
  { family: "Syne", weights: ["400", "500", "600", "700", "800"] },
  { family: "Syne Mono", weights: ["400"] },
  { family: "Syne Tactile", weights: ["400"] },
  { family: "Tac One", weights: ["400"] },
  { family: "Tagesschrift", weights: ["400"] },
  { family: "Tai Heritage Pro", weights: ["400", "700"] },
  { family: "Tajawal", weights: ["200", "300", "400", "500", "700", "800", "900"] },
  { family: "Tangerine", weights: ["400", "700"] },
  { family: "Tapestry", weights: ["400"] },
  { family: "Taprom", weights: ["400"] },
  { family: "TASA Explorer", weights: ["400", "500", "600", "700", "800"] },
  { family: "TASA Orbiter", weights: ["400", "500", "600", "700", "800"] },
  { family: "Tauri", weights: ["400"] },
  { family: "Taviraj", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900", "100i", "200i", "300i", "400i", "500i", "600i", "700i", "800i", "900i"] },
  { family: "Teachers", weights: ["400", "500", "600", "700", "800", "400i", "500i", "600i", "700i", "800i"] },
  { family: "Teko", weights: ["300", "400", "500", "600", "700"] },
  { family: "Tektur", weights: ["400", "500", "600", "700", "800", "900"] },
  { family: "Telex", weights: ["400"] },
  { family: "Tenali Ramakrishna", weights: ["400"] },
  { family: "Tenor Sans", weights: ["400"] },
  { family: "Text Me One", weights: ["400"] },
  { family: "Texturina", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900", "100i", "200i", "300i", "400i", "500i", "600i", "700i", "800i", "900i"] },
  { family: "Thasadith", weights: ["400", "700", "400i", "700i"] },
  { family: "The Girl Next Door", weights: ["400"] },
  { family: "The Nautigal", weights: ["400", "700"] },
  { family: "Tienne", weights: ["400", "700", "900"] },
  { family: "TikTok Sans", weights: ["300", "400", "500", "600", "700", "800", "900"] },
  { family: "Tillana", weights: ["400", "500", "600", "700", "800"] },
  { family: "Tilt Neon", weights: ["400"] },
  { family: "Tilt Prism", weights: ["400"] },
  { family: "Tilt Warp", weights: ["400"] },
  { family: "Timmana", weights: ["400"] },
  { family: "Tinos", weights: ["400", "700", "400i", "700i"] },
  { family: "Tiny5", weights: ["400"] },
  { family: "Tiro Bangla", weights: ["400", "400i"] },
  { family: "Tiro Devanagari Hindi", weights: ["400", "400i"] },
  { family: "Tiro Devanagari Marathi", weights: ["400", "400i"] },
  { family: "Tiro Devanagari Sanskrit", weights: ["400", "400i"] },
  { family: "Tiro Gurmukhi", weights: ["400", "400i"] },
  { family: "Tiro Kannada", weights: ["400", "400i"] },
  { family: "Tiro Tamil", weights: ["400", "400i"] },
  { family: "Tiro Telugu", weights: ["400", "400i"] },
  { family: "Tirra", weights: ["400", "500", "600", "700", "800", "900"] },
  { family: "Titan One", weights: ["400"] },
  { family: "Titillium Web", weights: ["200", "300", "400", "600", "700", "900", "200i", "300i", "400i", "600i", "700i"] },
  { family: "Tomorrow", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900", "100i", "200i", "300i", "400i", "500i", "600i", "700i", "800i", "900i"] },
  { family: "Tourney", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900", "100i", "200i", "300i", "400i", "500i", "600i", "700i", "800i", "900i"] },
  { family: "Trade Winds", weights: ["400"] },
  { family: "Train One", weights: ["400"] },
  { family: "Triodion", weights: ["400"] },
  { family: "Trirong", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900", "100i", "200i", "300i", "400i", "500i", "600i", "700i", "800i", "900i"] },
  { family: "Trispace", weights: ["100", "200", "300", "400", "500", "600", "700", "800"] },
  { family: "Trocchi", weights: ["400"] },
  { family: "Trochut", weights: ["400", "700", "400i"] },
  { family: "Truculenta", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Trykker", weights: ["400"] },
  { family: "Tsukimi Rounded", weights: ["300", "400", "500", "600", "700"] },
  { family: "Tuffy", weights: ["400", "700", "400i", "700i"] },
  { family: "Tulpen One", weights: ["400"] },
  { family: "Turret Road", weights: ["200", "300", "400", "500", "700", "800"] },
  { family: "Twinkle Star", weights: ["400"] },
  { family: "Ubuntu", weights: ["300", "400", "500", "700", "300i", "400i", "500i", "700i"] },
  { family: "Ubuntu Condensed", weights: ["400"] },
  { family: "Ubuntu Mono", weights: ["400", "700", "400i", "700i"] },
  { family: "Ubuntu Sans", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "100i", "200i", "300i", "400i", "500i", "600i", "700i", "800i"] },
  { family: "Ubuntu Sans Mono", weights: ["400", "500", "600", "700", "400i", "500i", "600i", "700i"] },
  { family: "Uchen", weights: ["400"] },
  { family: "Ultra", weights: ["400"] },
  { family: "Unbounded", weights: ["200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Uncial Antiqua", weights: ["400"] },
  { family: "Underdog", weights: ["400"] },
  { family: "Unica One", weights: ["400"] },
  { family: "UnifrakturCook", weights: ["700"] },
  { family: "UnifrakturMaguntia", weights: ["400"] },
  { family: "Unkempt", weights: ["400", "700"] },
  { family: "Unlock", weights: ["400"] },
  { family: "Unna", weights: ["400", "700", "400i", "700i"] },
  { family: "UoqMunThenKhung", weights: ["400"] },
  { family: "Updock", weights: ["400"] },
  { family: "Urbanist", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900", "100i", "200i", "300i", "400i", "500i", "600i", "700i", "800i", "900i"] },
  { family: "Vampiro One", weights: ["400"] },
  { family: "Varela", weights: ["400"] },
  { family: "Varela Round", weights: ["400"] },
  { family: "Varta", weights: ["300", "400", "500", "600", "700"] },
  { family: "Vast Shadow", weights: ["400"] },
  { family: "Vazirmatn", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900"] },
  { family: "Vend Sans", weights: ["300", "400", "500", "600", "700", "300i", "400i", "500i", "600i", "700i"] },
  { family: "Vesper Libre", weights: ["400", "500", "700", "900"] },
  { family: "Viaoda Libre", weights: ["400"] },
  { family: "Vibes", weights: ["400"] },
  { family: "Vibur", weights: ["400"] },
  { family: "Victor Mono", weights: ["100", "200", "300", "400", "500", "600", "700", "100i", "200i", "300i", "400i", "500i", "600i", "700i"] },
  { family: "Vidaloka", weights: ["400"] },
  { family: "Viga", weights: ["400"] },
  { family: "Vina Sans", weights: ["400"] },
  { family: "Voces", weights: ["400"] },
  { family: "Volkhov", weights: ["400", "700", "400i", "700i"] },
  { family: "Vollkorn", weights: ["400", "500", "600", "700", "800", "900", "400i", "500i", "600i", "700i", "800i", "900i"] },
  { family: "Vollkorn SC", weights: ["400", "600", "700", "900"] },
  { family: "Voltaire", weights: ["400"] },
  { family: "VT323", weights: ["400"] },
  { family: "Vujahday Script", weights: ["400"] },
  { family: "Waiting for the Sunrise", weights: ["400"] },
  { family: "Wallpoet", weights: ["400"] },
  { family: "Walter Turncoat", weights: ["400"] },
  { family: "Warnes", weights: ["400"] },
  { family: "Water Brush", weights: ["400"] },
  { family: "Waterfall", weights: ["400"] },
  { family: "Wavefont", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900", "1000"] },
  { family: "WDXL Lubrifont JP N", weights: ["400"] },
  { family: "WDXL Lubrifont SC", weights: ["400"] },
  { family: "WDXL Lubrifont TC", weights: ["400"] },
  { family: "Wellfleet", weights: ["400"] },
  { family: "Wendy One", weights: ["400"] },
  { family: "Whisper", weights: ["400"] },
  { family: "WindSong", weights: ["400", "500"] },
  { family: "Winky Rough", weights: ["300", "400", "500", "600", "700", "800", "900", "300i", "400i", "500i", "600i", "700i", "800i", "900i"] },
  { family: "Winky Sans", weights: ["300", "400", "500", "600", "700", "800", "900", "300i", "400i", "500i", "600i", "700i", "800i", "900i"] },
  { family: "Wire One", weights: ["400"] },
  { family: "Wittgenstein", weights: ["400", "500", "600", "700", "800", "900", "400i", "500i", "600i", "700i", "800i", "900i"] },
  { family: "Wix Madefor Display", weights: ["400", "500", "600", "700", "800"] },
  { family: "Wix Madefor Text", weights: ["400", "500", "600", "700", "800", "400i", "500i", "600i", "700i", "800i"] },
  { family: "Work Sans", weights: ["100", "200", "300", "400", "500", "600", "700", "800", "900", "100i", "200i", "300i", "400i", "500i", "600i", "700i", "800i", "900i"] },
  { family: "Workbench", weights: ["400"] },
  { family: "Xanh Mono", weights: ["400", "400i"] },
  { family: "Yaldevi", weights: ["200", "300", "400", "500", "600", "700"] },
  { family: "Yanone Kaffeesatz", weights: ["200", "300", "400", "500", "600", "700"] },
  { family: "Yantramanav", weights: ["100", "300", "400", "500", "700", "900"] },
  { family: "Yarndings 12", weights: ["400"] },
  { family: "Yarndings 12 Charted", weights: ["400"] },
  { family: "Yarndings 20", weights: ["400"] },
  { family: "Yarndings 20 Charted", weights: ["400"] },
  { family: "Yatra One", weights: ["400"] },
  { family: "Yellowtail", weights: ["400"] },
  { family: "Yeon Sung", weights: ["400"] },
  { family: "Yeseva One", weights: ["400"] },
  { family: "Yesteryear", weights: ["400"] },
  { family: "Yomogi", weights: ["400"] },
  { family: "Young Serif", weights: ["400"] },
  { family: "Yrsa", weights: ["300", "400", "500", "600", "700", "300i", "400i", "500i", "600i", "700i"] },
  { family: "Ysabeau", weights: ["1", "100", "200", "300", "400", "500", "600", "700", "800", "900", "1000", "1000i", "100i", "1i", "200i", "300i", "400i", "500i", "600i", "700i", "800i", "900i"] },
  { family: "Ysabeau Infant", weights: ["1", "100", "200", "300", "400", "500", "600", "700", "800", "900", "1000", "1000i", "100i", "1i", "200i", "300i", "400i", "500i", "600i", "700i", "800i", "900i"] },
  { family: "Ysabeau Office", weights: ["1", "100", "200", "300", "400", "500", "600", "700", "800", "900", "1000", "1000i", "100i", "1i", "200i", "300i", "400i", "500i", "600i", "700i", "800i", "900i"] },
  { family: "Ysabeau SC", weights: ["1", "100", "200", "300", "400", "500", "600", "700", "800", "900", "1000"] },
  { family: "Yuji Boku", weights: ["400"] },
  { family: "Yuji Hentaigana Akari", weights: ["400"] },
  { family: "Yuji Hentaigana Akebono", weights: ["400"] },
  { family: "Yuji Mai", weights: ["400"] },
  { family: "Yuji Syuku", weights: ["400"] },
  { family: "Yusei Magic", weights: ["400"] },
  { family: "Yuyu", weights: ["400"] },
  { family: "Yuyu Short", weights: ["400"] },
  { family: "Zain", weights: ["200", "300", "400", "700", "800", "900", "300i", "400i"] },
  { family: "Zalando Sans", weights: ["200", "300", "400", "500", "600", "700", "800", "900", "200i", "300i", "400i", "500i", "600i", "700i", "800i", "900i"] },
  { family: "Zalando Sans Expanded", weights: ["200", "300", "400", "500", "600", "700", "800", "900", "200i", "300i", "400i", "500i", "600i", "700i", "800i", "900i"] },
  { family: "Zalando Sans SemiExpanded", weights: ["200", "300", "400", "500", "600", "700", "800", "900", "200i", "300i", "400i", "500i", "600i", "700i", "800i", "900i"] },
  { family: "ZCOOL KuaiLe", weights: ["400"] },
  { family: "ZCOOL QingKe HuangYou", weights: ["400"] },
  { family: "ZCOOL XiaoWei", weights: ["400"] },
  { family: "Zen Antique", weights: ["400"] },
  { family: "Zen Antique Soft", weights: ["400"] },
  { family: "Zen Dots", weights: ["400"] },
  { family: "Zen Kaku Gothic Antique", weights: ["300", "400", "500", "700", "900"] },
  { family: "Zen Kaku Gothic New", weights: ["300", "400", "500", "700", "900"] },
  { family: "Zen Kurenaido", weights: ["400"] },
  { family: "Zen Loop", weights: ["400", "400i"] },
  { family: "Zen Maru Gothic", weights: ["300", "400", "500", "700", "900"] },
  { family: "Zen Old Mincho", weights: ["400", "500", "600", "700", "900"] },
  { family: "Zen Tokyo Zoo", weights: ["400"] },
  { family: "Zeyada", weights: ["400"] },
  { family: "Zhi Mang Xing", weights: ["400"] },
  { family: "Zilla Slab", weights: ["300", "400", "500", "600", "700", "300i", "400i", "500i", "600i", "700i"] },
  { family: "Zilla Slab Highlight", weights: ["400", "700"] },
];

const GOOGLE_FONT_FAMILY_SET: ReadonlySet<string> = new Set(GOOGLE_FONTS.map((f) => f.family));

export function isGoogleFontFamily(family: string): boolean {
  return GOOGLE_FONT_FAMILY_SET.has(family);
}
